(function () {
  /* swatch-video-autoplay-v5 */
  if (!customElements || customElements.get('dd-sticky-footer')) return;

  var SCROLL_TO_OFFSET = 96;
  var VISIBILITY_SHOW_PX = 300;
  var MIN_STICKY_W = 320;
  var LAYOUT_RESYNC_MS = [200, 600, 1200];
  var GRID_COL_FR_RIGHT = 45;
  var GRID_COL_FR_TOTAL = 55 + 45;

  function formatMoneyPlain(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = window.shopMoneyFormat ? String(window.shopMoneyFormat) : '${{amount}}';
    fmt = fmt.replace(/<[^>]*>/g, '');
    if (fmt.indexOf('hide-price-guest') !== -1 || fmt.indexOf('&lt;') !== -1) {
      var tmp = document.createElement('div');
      tmp.innerHTML = fmt;
      fmt = tmp.textContent || '';
    }
    fmt = fmt.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '');
    // Thousands grouping: Liquid's money filters emit "$1,575" — without
    // grouping, JS-driven updates (variant change) regress to "$1575" and
    // visibly disagree with the server-rendered prices on the page.
    var group = function (intStr, sep) {
      return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    };
    var dollars = (Number(cents) / 100).toFixed(2);
    var parts = dollars.split('.');
    var amountGrouped = group(parts[0], ',') + '.' + parts[1];
    var amountCommaSep = group(parts[0], '.') + ',' + parts[1];
    var amountNoDecimals = group(String(Math.round(Number(cents) / 100)), ',');
    var out = fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amountCommaSep)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/gi, amountGrouped);
    out = out.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '');
    // Match Liquid's `money_without_trailing_zeros` so the sticky ATC
    // price is consistent with the in-page ATC/hero price ("$180", not
    // "$180.00"). Non-zero decimals are preserved; currency suffixes
    // like " USD" stay intact via the negative look-ahead.
    return out.replace(/([.,])00(?!\d)/, '');
  }

  class DdStickyFooter extends HTMLElement {
    connectedCallback() {
      /* Event seat PDP: portal the fixed sticky out of the main-product
         section so the 100rem buy-box rail cannot affect its geometry. */
      if (
        this.classList.contains('dd-sticky-footer--event') &&
        document.body &&
        this.parentNode !== document.body
      ) {
        document.body.appendChild(this);
      }

      this.button = this.querySelector('[data-dd-sf-atc], .dd-sticky-footer__atc');
      this.atcLabel = this.querySelector('[data-dd-sf-atc-label]');
      this.priceEl = this.querySelector('[data-dd-sf-price], .dd-sticky-footer__price');
      /* `_unitPriceCents` is the source of truth for total-price
         recomputation. Seeded from the price element's
         `data-unit-price` (rendered by Liquid as `sf_variant.price`)
         and updated on every variant change so qty bumps always
         multiply against the *current* variant. */
      if (this.priceEl) {
        var initUnit = parseInt(this.priceEl.getAttribute('data-unit-price'), 10);
        this._unitPriceCents = isFinite(initUnit) ? initUnit : null;
      }
      /* First-order (SALONTRIAL15) recalc pill. Server-rendered at qty 1
         for eligible zero-order customers (see the meta-left block in
         sections/main-product.liquid); `_renderTrialPill()` keeps its
         sale/compare pair in lockstep with the main total on every qty
         and variant change. */
      this.trialPill = this.querySelector('[data-dd-sf-trial-pill]');
      if (this.trialPill) {
        this.trialSaleEl = this.trialPill.querySelector('[data-dd-sf-trial-sale]');
        this.trialCompareEl = this.trialPill.querySelector('[data-dd-sf-trial-compare]');
        var trialPct = parseInt(this.trialPill.getAttribute('data-trial-percent'), 10);
        this._trialPercent = isFinite(trialPct) && trialPct > 0 && trialPct < 100 ? trialPct : null;
        this._syncTrialAppliedLabel();
      }
      this.pillsContainer = this.querySelector('[data-dd-sf-pills]');
      this.swatchPreview = this.querySelector('[data-dd-sf-swatch-preview]');
      if (this.swatchPreview) {
        var initSwatchVideo = this.swatchPreview.querySelector('video');
        if (initSwatchVideo) {
          this._primeSwatchVideo(initSwatchVideo);
          this._bindSwatchVideoSelfHeal(initSwatchVideo);
        }
      }
      this.qtyWrap = this.querySelector('[data-dd-sf-qty]');
      this.qtyValueEl = this.querySelector('[data-dd-sf-qty-value]');
      this.notifyTrigger = this.querySelector('[data-dd-sf-notify-toggle]');
      this.notifyHost = this.querySelector('dd-notify-when-available.dd-notify--sticky-inline');
      this.notifyLabel = this.querySelector('[data-dd-sf-notify-label]');
      this.notifyBell = this.querySelector('[data-dd-sf-notify-bell]');
      this.notifyCheck = this.querySelector('[data-dd-sf-notify-check]');
      this.notifySpinner = this.querySelector('[data-dd-sf-notify-spinner]');
      this.shipInstock = this.querySelector('[data-dd-sf-ship-instock]');
      this.shipLowstock = this.querySelector('[data-dd-sf-ship-lowstock]');
      this.shipLowstockCount = this.querySelector('[data-dd-sf-lowstock-count]');
      this.shipCustom = this.querySelector('[data-dd-sf-ship-custom]');
      this.shipSoldout = this.querySelector('[data-dd-sf-ship-soldout]');
      this.shipNotifyLinks = this.querySelectorAll('[data-dd-sf-ship-notify]');
      this.shipNotOffered = this.querySelector('[data-dd-sf-ship-not-offered]');
      this.shipDigital = this.querySelector('[data-dd-sf-ship-digital]');
      this.shipTicketsLine = this.querySelector('[data-dd-sf-ship-tickets]');
      this.shipTicketsText = this.querySelector('[data-dd-sf-ship-tickets-text]');
      this.shipTicketsDot = this.shipTicketsLine
        ? this.shipTicketsLine.querySelector('.dd-sticky-footer__ship-dot')
        : null;
      this.eventTicketCapacity = parseInt(this.dataset.eventTicketCapacity || '0', 10);
      if (!isFinite(this.eventTicketCapacity) || this.eventTicketCapacity < 0) {
        this.eventTicketCapacity = 0;
      }
      this.customBanner = this.querySelector('[data-dd-sf-custom-banner]');
      this.customBadgeEl = this.querySelector('[data-dd-sf-custom-badge]');
      this.isGuest = this.dataset.guest === 'true';
      this.isGuestColorRingPurchase = this.dataset.guestColorRingPurchase === 'true';
      this.guestDiscountCode = (this.dataset.guestDiscountCode || '').trim();
      this.guestDiscountHours = parseInt(this.dataset.guestDiscountHours || '48', 10);
      if (isNaN(this.guestDiscountHours) || this.guestDiscountHours < 1) this.guestDiscountHours = 48;
      this.guestOfferRow = this.querySelector('[data-dd-sf-guest-offer-row]');
      this.guestOfferCodeText = this.querySelector('[data-dd-sf-guest-offer-code-text]');
      this.guestOfferHoursText = this.querySelector('[data-dd-sf-guest-offer-hours-text]');
      // The default guest CTA ("Exclusively for professionals · [Apply]").
      // Both rows render server-side on the color-ring PDP (see
      // sections/main-product.liquid) — `updateGuestOfferRow()` flips them
      // in opposite directions based on the applied-breadcrumb state.
      this.guestApplyRow = this.querySelector('[data-dd-sf-guest-apply-row]');

      // ── PDP-level applied-state surfaces ───────────────────────────────
      // The sticky footer owns the single source of truth for the applied
      // breadcrumb (`dd_color_ring_guest_offer_v1` + `?dd_offer_code=…`),
      // so it also orchestrates these out-of-tree surfaces that need to
      // flip in lockstep:
      //   • guestDiscountPills — `[data-dd-guest-discount-pill]`. Two on
      //     the color-ring PDP (one in the head pricing block, one in the
      //     sticky footer itself). Both rendered hidden; revealed when
      //     the applied state is active. See snippets/dd-pdp-guest-discount-pill.liquid.
      //   • guestTeaser        — `[data-dd-pdp-guest-teaser]`. The soft
      //     "Pros save more — Apply" link. Rendered visible by default
      //     for guests on color ring; hidden when the applied pill is
      //     revealed (never stack the two).
      //   • tierPills          — `[data-dd-discount-pill]` / `[data-dd-discount-pill-footer]`.
      //     Only rendered for logged-in customers. During the 48h post-
      //     approval window we hide these to let the applied pill take
      //     priority (agreed policy — the promo is more specific/timely
      //     than the tier pill).
      // We query on `document` because the head pricing block lives outside
      // the sticky footer subtree; `this.querySelector` wouldn't find it.
      this.guestDiscountPills = document.querySelectorAll('[data-dd-guest-discount-pill]');
      this.guestTeaser = document.querySelector('[data-dd-pdp-guest-teaser]');
      // NodeList, not single: the tier pill renders in TWO places on the
      // PDP (head pricing block + buy-zone/pro-line, the latter mobile-
      // only). Both must suppress/restore together in the promo window.
      this.tierPillsHead = document.querySelectorAll('[data-dd-discount-pill]');
      this.tierPillFooter = document.querySelector('[data-dd-discount-pill-footer]');
      this.sectionId = this.dataset.section || this.dataset.sectionId || '';
      this.infoDomId = this.dataset.pdpInfoId || this.dataset.infoDomId || '';
      this.currentVariantId = null;
      this.isAdding = false;
      this._previewRaf = 0;
      this._syncLayout = this._syncInfoColumnGeometry.bind(this);
      this._boundQtyInput = null;
      this._onBoundQtySync = null;
      /* Which chip face the disclosure panel is showing: 'qty',
         'profit', or null (closed). Pros only — guests keep the
         auto-show chip and never touch this. */
      this._bundlePanelFace = null;
      /* Click-pinned face while hover-preview is active on desktop. */
      this._bundlePanelPinnedFace = null;
      this._variantSubUnsubscribe = null;
      this._swatchRoot = null;
      this._onSwatchInteract = null;
      this._chatOpen = document.documentElement.classList.contains('dd-chat-active');
      this._onChatToggle = null;

      window.addEventListener('resize', this._syncLayout, { passive: true });

      var pi = document.querySelector('product-info');
      if (pi && typeof ResizeObserver !== 'undefined') {
        this._layoutRo = new ResizeObserver(this._syncLayout);
        this._layoutRo.observe(pi);
      }
      this._syncLayout();
      requestAnimationFrame(this._syncLayout);
      var self = this;
      LAYOUT_RESYNC_MS.forEach(function (ms) {
        setTimeout(function () {
          self._syncLayout();
        }, ms);
      });

      this.listenForVariantChanges();
      this.listenForSwatchChanges();
      this.bindPillScroll();
      this.bindClick();
      this.bindQty();
      this.bindFormQtySync();
      this.bindBundleApply();
      this.bindBundlePills();
      this.refreshBundleChip();
      this.bindNotifyTrigger();
      this.initStickyVisibility();
      this.bindChatCoordination();
      this.initFromDom();
      this.updateGuestOfferRow();
      this.bindAppliedSync();
      this.bindGuestPillCopy();
      this.bindDragCollapse();

      // Publish --dd-sticky-footer-h on :root whenever we're visible so other
      // fixed-bottom UI (review nudge, cart toasts) can stack above the footer
      // via `calc(20px + var(--dd-sticky-footer-h, 0px))`. The ResizeObserver
      // keeps the value accurate across collapse/expand + notify-panel open.
      // Value is removed entirely when the footer is hidden (see
      // `_applyStickyVisibility`) so consumers fall back to the 0px default.
      if (typeof ResizeObserver !== 'undefined') {
        this._stickyHeightRo = new ResizeObserver(() => this._publishStickyHeight());
        this._stickyHeightRo.observe(this);
      }
    }

    _publishStickyHeight() {
      if (!this.classList.contains('is--visible') || this.classList.contains('is--exiting')) return;
      var h = Math.round(this.getBoundingClientRect().height) || 0;
      if (h) document.documentElement.style.setProperty('--dd-sticky-footer-h', h + 'px');
    }

    _clearStickyHeight() {
      document.documentElement.style.removeProperty('--dd-sticky-footer-h');
    }

    // ---------------------------------------------------------------------
    // Notify-me trigger wiring.
    //
    // The single pill in the action row drives the entire flow:
    //   1. Closed  → click → host.open()
    //   2. Open    → click → host.submit()
    //   3. Submitting → spinner + disabled
    //   4. Success → panel closes, trigger shows "You're on the list" + check
    //
    // Label / icon / disabled are all swapped in response to events fired by
    // <dd-notify-when-available> — the custom element owns the source of
    // truth, the footer just reflects it.
    // ---------------------------------------------------------------------
    bindNotifyTrigger() {
      if (!this.notifyTrigger || !this.notifyHost) return;
      var self = this;

      this._onNotifyTriggerClick = function (e) {
        if (e) e.preventDefault();
        if (!self.notifyHost) return;
        if (self.notifyTrigger && self.notifyTrigger.disabled) return;

        // Second click while open → submit. First click (or re-open after a
        // soft-error + close) → open.
        if (self.notifyHost.isOpen) {
          if (typeof self.notifyHost.submit === 'function') self.notifyHost.submit();
        } else {
          if (typeof self.notifyHost.open === 'function') self.notifyHost.open();
        }
      };
      this.notifyTrigger.addEventListener('click', this._onNotifyTriggerClick);
      if (this.shipNotifyLinks && this.shipNotifyLinks.length) {
        this.shipNotifyLinks.forEach(function (link) {
          link.addEventListener('click', self._onNotifyTriggerClick);
        });
      }

      this._onNotifyOpen = function (e) {
        self.classList.add('dd-sticky-footer--notify-open');
        var channel = (e && e.detail && e.detail.channel) || 'email';
        self.setNotifyTriggerState('open', { channel: channel });
      };
      this._onNotifyClose = function () {
        self.classList.remove('dd-sticky-footer--notify-open');
        // If the shopper subscribed, keep the subscribed face; otherwise go
        // back to the idle "Notify me" pill.
        if (self.notifyHost && self.notifyHost.isSubscribed) {
          self.setNotifyTriggerState('subscribed');
        } else {
          self.setNotifyTriggerState('idle');
        }
      };
      this._onNotifyChannelChange = function (e) {
        if (!self.classList.contains('dd-sticky-footer--notify-open')) return;
        var channel = (e && e.detail && e.detail.channel) || 'email';
        self.setNotifyTriggerState('open', { channel: channel });
      };
      this._onNotifySubmitStart = function () {
        self.setNotifyTriggerState('submitting');
      };
      this._onNotifySubmitEnd = function () {
        // If success handler already switched us to subscribed, don't clobber.
        if (self.notifyHost && self.notifyHost.isSubscribed) return;
        // Otherwise re-enable the open face so a retry is possible.
        if (self.classList.contains('dd-sticky-footer--notify-open')) {
          var channel = self.notifyHost && self.notifyHost.selectedChannel;
          self.setNotifyTriggerState('open', { channel: channel || 'email' });
        } else {
          self.setNotifyTriggerState('idle');
        }
      };
      this._onNotifySuccess = function () {
        // Collapse the form — the subscribed face on the trigger IS the
        // confirmation. The internal success toast is still rendered inside
        // the panel for anyone who re-opens.
        self.setNotifyTriggerState('subscribed');
        try { self.notifyHost.close(); } catch (_) { /* noop */ }
      };
      this._onNotifySubscribedState = function (e) {
        // Keep trigger in sync when the host flips subscribed/unsubscribed
        // due to a variant swap (dedupe via sessionStorage). Ignore while
        // the panel is open — the open/submit state machine owns the label.
        if (!self.notifyHost || self.notifyHost.isOpen) return;
        var subscribed = !!(e && e.detail && e.detail.subscribed);
        self.setNotifyTriggerState(subscribed ? 'subscribed' : 'idle');
      };

      this.notifyHost.addEventListener('dd-notify:open', this._onNotifyOpen);
      this.notifyHost.addEventListener('dd-notify:close', this._onNotifyClose);
      this.notifyHost.addEventListener('dd-notify:channel-change', this._onNotifyChannelChange);
      this.notifyHost.addEventListener('dd-notify:submit-start', this._onNotifySubmitStart);
      this.notifyHost.addEventListener('dd-notify:submit-end', this._onNotifySubmitEnd);
      this.notifyHost.addEventListener('dd-notify:success', this._onNotifySuccess);
      this.notifyHost.addEventListener('dd-notify:subscribed-state', this._onNotifySubscribedState);

      // Bootstrap: if the host already marked itself subscribed (dedupe via
      // sessionStorage on connect), reflect that on the trigger now.
      if (this.notifyHost.isSubscribed) {
        this.setNotifyTriggerState('subscribed');
      }
    }

    // Label / icon / disabled / aria state for the notify-trigger pill.
    setNotifyTriggerState(state, opts) {
      if (!this.notifyTrigger) return;
      opts = opts || {};
      var channel = opts.channel || 'email';

      // Reset visual flags — state-specific branches re-apply them.
      this.notifyTrigger.classList.remove(
        'is--open',
        'is--submitting',
        'is--subscribed'
      );
      this.notifyTrigger.disabled = false;
      this.notifyTrigger.setAttribute('aria-expanded', state === 'open' || state === 'submitting' ? 'true' : 'false');
      if (this.notifyBell) this.notifyBell.hidden = false;
      if (this.notifyCheck) this.notifyCheck.hidden = true;
      if (this.notifySpinner) this.notifySpinner.hidden = true;

      var label = 'Notify me';
      if (state === 'idle') {
        label = 'Notify me';
      } else if (state === 'open') {
        this.notifyTrigger.classList.add('is--open');
        label = channel === 'sms'
          ? 'Yes, Text me when available'
          : 'Yes, Email me when available';
      } else if (state === 'submitting') {
        this.notifyTrigger.classList.add('is--open', 'is--submitting');
        this.notifyTrigger.disabled = true;
        if (this.notifyBell) this.notifyBell.hidden = true;
        if (this.notifySpinner) this.notifySpinner.hidden = false;
        label = 'Subscribing…';
      } else if (state === 'subscribed') {
        this.notifyTrigger.classList.add('is--subscribed');
        this.notifyTrigger.disabled = true;
        if (this.notifyBell) this.notifyBell.hidden = true;
        if (this.notifyCheck) this.notifyCheck.hidden = false;
        label = "You're on the list";
      }

      if (this.notifyLabel) this._swapText(this.notifyLabel, label);
      if (this.shipNotifyLinks && this.shipNotifyLinks.length) {
        var hideShipNotify = state === 'subscribed';
        this.shipNotifyLinks.forEach(function (link) {
          link.hidden = hideShipNotify;
        });
      }
    }

    // ── Animation helpers ─────────────────────────────────────────────
    // Every visible mutation on the sticky footer (price, label, qty,
    // stock indicator, swatch thumb, pills, notify trigger) routes
    // through one of these helpers so state changes feel purposeful
    // instead of snapping. All helpers no-op when the value hasn't
    // changed, when it's a first-time fill (empty → value), or when the
    // user prefers reduced motion.
    _prefersReducedMotion() {
      if (this._reducedMotion !== undefined) return this._reducedMotion;
      try {
        this._reducedMotion = !!(
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
      } catch (e) {
        this._reducedMotion = false;
      }
      return this._reducedMotion;
    }

    _replay(el, cls) {
      if (!el) return;
      el.classList.remove(cls);
      // Force a reflow so re-adding the class restarts the animation.
      void el.offsetWidth;
      el.classList.add(cls);
    }

    _swapText(el, next) {
      if (!el) return;
      var str = next == null ? '' : String(next);
      if (el.textContent === str) return;
      var hadPrev = el.textContent && el.textContent.trim().length > 0;
      el.textContent = str;
      if (!hadPrev || this._prefersReducedMotion()) return;
      this._replay(el, 'dd-sf-swap-in');
    }

    // ── ATC label text swap with optional marquee fallback ───────────
    // Routes all ATC-label mutations through a single path so the
    // marquee DOM/state gets torn down cleanly before the next label
    // is installed. `marqueeable: true` is reserved for labels that
    // can realistically overflow the button (today: the "Available in
    // X, Y, Z…" availability string on OOS variants). Everything else
    // — "Add to Cart", "Adding…", "Select options", etc. — short-
    // circuits past the overflow check since those strings always fit.
    _setAtcLabel(text, options) {
      if (!this.atcLabel) return;
      var marqueeable = !!(options && options.marqueeable);
      // Clear any active marquee state from the previous label so the
      // text swap lands on a plain span, not inside a track element.
      this.atcLabel.classList.remove('dd-sticky-footer__atc-label--marquee');
      this.atcLabel.style.removeProperty('--dd-sf-atc-marquee-duration');
      this._swapText(this.atcLabel, text);
      if (!marqueeable) return;
      if (this._prefersReducedMotion()) return;
      var label = this.atcLabel;
      var self = this;
      // Measure after paint. Using rAF (not setTimeout) so the layout
      // read happens in the same frame as the text insertion — avoids
      // a one-frame "flash of unscrolled text" before the marquee
      // engages. The ±1px slack absorbs sub-pixel rounding noise.
      requestAnimationFrame(function () {
        if (!label.isConnected) return;
        if (label.scrollWidth - 1 <= label.clientWidth) return;
        self._activateAtcLabelMarquee(text);
      });
    }

    _activateAtcLabelMarquee(text) {
      if (!this.atcLabel) return;
      // Two identical segments in a track translate by -50% for a
      // seamless loop: the moment segment A scrolls off the left,
      // segment B is already filling the visible frame. Each segment
      // carries its own right-padding so there's a natural "pause" of
      // whitespace between repetitions instead of the text
      // immediately butting against itself.
      var segA = document.createElement('span');
      segA.className = 'dd-sticky-footer__atc-label-segment';
      segA.textContent = text;
      var segB = segA.cloneNode(true);
      segB.setAttribute('aria-hidden', 'true');
      var track = document.createElement('span');
      track.className = 'dd-sticky-footer__atc-label-track';
      track.appendChild(segA);
      track.appendChild(segB);
      this.atcLabel.innerHTML = '';
      this.atcLabel.appendChild(track);
      // Duration proportional to text length so a short list reads
      // briskly and a long list doesn't strobe past. Clamped to
      // [8s, 18s] so the pace feels intentional either way.
      var durationMs = Math.min(18000, Math.max(8000, text.length * 200));
      this.atcLabel.style.setProperty(
        '--dd-sf-atc-marquee-duration',
        (durationMs / 1000) + 's'
      );
      this.atcLabel.classList.add('dd-sticky-footer__atc-label--marquee');
    }

    _swapNumber(el, next) {
      if (!el) return;
      var prev = parseInt(el.textContent, 10);
      var n = parseInt(next, 10);
      if (isNaN(n)) {
        this._swapText(el, next);
        return;
      }
      var str = String(n);
      if (el.textContent === str) return;
      var hadPrev = !isNaN(prev);
      el.textContent = str;
      if (!hadPrev || this._prefersReducedMotion()) return;
      // Remove both directional classes before replaying so consecutive
      // same-direction ticks still animate.
      el.classList.remove('dd-sf-tick-up', 'dd-sf-tick-down');
      this._replay(el, n < prev ? 'dd-sf-tick-down' : 'dd-sf-tick-up');
    }

    _bumpEl(el) {
      if (!el || this._prefersReducedMotion()) return;
      this._replay(el, 'dd-sf-bump');
    }

    _swapImage(img, src) {
      if (!img || !src) return;
      var curr = img.getAttribute('src');
      if (curr === src) return;
      var hadPrev = !!curr;
      img.src = src;
      if (!hadPrev || this._prefersReducedMotion()) return;
      this._replay(img, 'dd-sf-swap-in');
    }

    /*
      Swatch-preview media pending state. During a variant switch the
      thumbnail deliberately keeps showing the PREVIOUS variant's media
      until the section render lands (the correct media list lives in
      the server-rendered gallery — see the skipPreview note on
      _applyVariantState). Without a signal, that reads as "wrong
      image": the shopper picked Beach and still sees Blackout. The
      is--media-pending class scrims the stale thumb and spins a small
      ring over it (CSS in dd-pdp-sticky-atc.css).

      The failsafe timer is the never-stuck guarantee: if the section
      render dies (network error, aborted tab) no variantChange ever
      arrives to settle the state, and a permanent spinner is worse
      than a stale thumb. It only clears a class — no fetches.
    */
    _setSwatchMediaPending(on) {
      if (!this.swatchPreview) return;
      this.swatchPreview.classList.toggle('is--media-pending', !!on);
      if (this._swatchPendingT) {
        clearTimeout(this._swatchPendingT);
        this._swatchPendingT = 0;
      }
      if (on) {
        this._swatchPendingT = setTimeout(() => {
          if (this.swatchPreview) this.swatchPreview.classList.remove('is--media-pending');
          this._swatchPendingT = 0;
        }, 6000);
      }
    }

    /*
      Called at the end of every updateSwatchPreview pass. If the swap
      just pointed the <img> at a not-yet-downloaded file, hold the
      spinner until the pixels are actually decoded; otherwise clear
      now. Videos clear immediately: they render progressively from
      the poster/first frame, so there's no "wrong image" beat to mask.
    */
    _settleSwatchMediaPending() {
      if (!this.swatchPreview) return;
      if (!this.swatchPreview.classList.contains('is--media-pending')) return;
      var img = this.swatchPreview.querySelector('img');
      if (img && img.style.display !== 'none' && !img.complete) {
        var clear = () => this._setSwatchMediaPending(false);
        img.addEventListener('load', clear, { once: true });
        img.addEventListener('error', clear, { once: true });
        return; // failsafe timer from the pending=true call stays armed
      }
      this._setSwatchMediaPending(false);
    }

    _setStockState(key) {
      // key ∈ { 'instock', 'lowstock', 'custom', 'soldout', 'notoffered',
      //        'digital', null }
      // 'notoffered' is the Drop Dead-specific state for color × texture
      // combos the brand doesn't produce — distinct from 'soldout' because
      // there's no future restock event to anticipate.
      if (this._stockKey === key) return;
      var pills = {
        instock: this.shipInstock,
        lowstock: this.shipLowstock,
        custom: this.shipCustom,
        soldout: this.shipSoldout,
        notoffered: this.shipNotOffered,
        digital: this.shipDigital,
      };
      var reduced = this._prefersReducedMotion();
      var hadPrev = this._stockKey !== undefined;
      var self = this;
      Object.keys(pills).forEach(function (k) {
        var el = pills[k];
        if (!el) return;
        if (k === key) {
          el.hidden = false;
          if (hadPrev && !reduced) self._replay(el, 'dd-sf-swap-in');
        } else {
          el.hidden = true;
        }
      });
      if (key === 'instock' && typeof window.__ddShipCountdownUpdate === 'function') {
        window.__ddShipCountdownUpdate();
      }
      this._stockKey = key;
    }

    initFromDom() {
      var script = document.querySelector('variant-selects script[data-selected-variant]');
      if (!script) return;
      try {
        var v = JSON.parse(script.textContent);
        if (!v || !v.id) return;
        this.currentVariantId = v.id;

        var sw = document.querySelector('dd-swatch-selector');
        if (sw) this.syncPills(sw);

        if (this.classList.contains('dd-sticky-footer--event')) {
          this.updateEventTickets();
        }

        if (!this.isGuest) {
          if (this.priceEl && v.price != null) {
            this._unitPriceCents = v.price;
            this.priceEl.setAttribute('data-unit-price', String(v.price));
            this._renderTotalPrice();
          }

          if (this.button) {
            this.syncButtonFromRenderedHtml(null, v);
          }

          this.updateShippingAndCustom(v);
          this.schedulePreviewRefresh(v);
        }
      } catch (e) {}
    }

    getProductForm() {
      var byId = this.sectionId ? document.getElementById('product-form-' + this.sectionId) : null;
      if (byId) return byId;

      var infoRoot =
        (this.infoDomId && document.getElementById(this.infoDomId)) || document.querySelector('product-info');
      if (infoRoot) {
        var scoped = infoRoot.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
        if (scoped) return scoped;
      }

      return document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]');
    }

    getMainSubmitButton() {
      var form = this.getProductForm();
      if (!form) return null;
      return form.querySelector('.product-form__submit') || form.querySelector('[name="add"]');
    }

    getQuantityInput(form) {
      var src = form || this.getProductForm();
      if (!src) return null;
      return src.querySelector('input[name="quantity"]');
    }

    buildAddItemPayload(variantId, quantity) {
      var item = { id: Number(variantId), quantity: Number(quantity) || 1 };
      var form = this.getProductForm();
      if (!form || typeof FormData === 'undefined') return item;

      var fd = new FormData(form);
      var properties = {};

      fd.forEach(function (rawVal, key) {
        if (!key) return;
        if (key === 'id' || key === 'quantity' || key === 'form_type' || key === 'utf8') return;
        if (key === 'selling_plan') {
          var sp = String(rawVal || '').trim();
          if (sp) item.selling_plan = sp;
          return;
        }
        if (key.indexOf('properties[') === 0 && key.slice(-1) === ']') {
          var propName = key.slice(11, -1);
          if (!propName) return;
          var propVal = String(rawVal == null ? '' : rawVal);
          if (!propVal) return;
          properties[propName] = propVal;
        }
      });

      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    initStickyVisibility() {
      this._pastThreshold = false;
      this._mainAtcVisible = false;
      this._footerVisible = false;
      // Default true so non-mobile viewports and PDPs without a Color
      // option group (courses, single-variant products) are unaffected by
      // the gate. `_sampleColorAnchor()` flips it to a real read on first
      // scroll/resize sample below.
      this._pastColorAnchor = true;

      var customShowPx = parseInt(this.dataset.showPx || '', 10);
      this._showPx = isNaN(customShowPx) ? VISIBILITY_SHOW_PX : customShowPx;

      this._onStickyScroll = () => {
        var scrolled = (window.scrollY || document.documentElement.scrollTop) > this._showPx;
        if (scrolled !== this._pastThreshold) this._pastThreshold = scrolled;

        this._sampleColorAnchor();
        if (!this._mainAtcIo) this._sampleMainAtcVisibility();
        this._applyStickyVisibility();
      };

      window.addEventListener('scroll', this._onStickyScroll, { passive: true });
      window.addEventListener('resize', this._onStickyScroll, { passive: true });

      // Re-evaluate when the viewport crosses the mobile/desktop boundary —
      // e.g. orientation change on a tablet. Without this, a user who
      // rotates landscape→portrait while above the color anchor would keep
      // seeing the sticky from the desktop branch's "always pass" default.
      if (window.matchMedia) {
        this._mqColorGate = window.matchMedia('(max-width: 1023px)');
        this._onColorGateMq = () => {
          this._sampleColorAnchor();
          this._applyStickyVisibility();
        };
        if (this._mqColorGate.addEventListener) {
          this._mqColorGate.addEventListener('change', this._onColorGateMq);
        } else if (this._mqColorGate.addListener) {
          this._mqColorGate.addListener(this._onColorGateMq);
        }
      }

      this._refreshMainAtcObserver();
      this._initFooterObserver();

      var productInfo = document.querySelector('product-info');
      if (productInfo && typeof MutationObserver !== 'undefined') {
        this._atcMo = new MutationObserver(() => this._refreshMainAtcObserver());
        this._atcMo.observe(productInfo, { childList: true, subtree: true });
      }

      this._onStickyScroll();
    }

    // ── Mobile color-anchor gate ────────────────────────────────────
    // On mobile (≤1023px) we delay revealing the sticky ATC until the
    // shopper has actually scrolled into the Color option group. The
    // 300px scroll threshold alone fired while still inside the
    // gallery/price area, which felt premature. Desktop keeps the
    // original threshold-only behaviour because the inline ATC sits in
    // the right column and is rarely off-screen at 300px scrolled.
    //
    // Bidirectional: once the user scrolls all the way back up above
    // the color group again, the sticky tucks away. Defaults to `true`
    // (no gate) when no Color option exists or on desktop, so other
    // PDPs (courses, single-option products) are unaffected.
    _sampleColorAnchor() {
      if (!this._isMobileColorGate()) {
        this._pastColorAnchor = true;
        return;
      }
      var sw = document.querySelector('dd-swatch-selector');
      if (!sw) {
        this._pastColorAnchor = true;
        return;
      }
      var groups = sw.querySelectorAll('[data-dd-option-group]');
      var colorEl = null;
      for (var i = 0; i < groups.length; i++) {
        var name = (groups[i].getAttribute('data-option-name') || '').toLowerCase().trim();
        if (name === 'color' || name === 'colour') { colorEl = groups[i]; break; }
      }
      if (!colorEl) {
        this._pastColorAnchor = true;
        return;
      }
      // True once the group's top edge has risen into the TOP HALF of
      // the viewport — the shopper has scrolled the color section into
      // reading position. The original `rect.top < 0` (fully scrolled
      // past) made the sticky show far too late on mobile: on a tall
      // PDP the whole color group had to leave the screen first. The
      // half-viewport line still keeps the reveal out of the gallery/
      // price zone (the reason this gate exists) while firing roughly
      // a full screen earlier. Stays true while the user remains at or
      // below color; flips back when they scroll back up above it.
      var rect = colorEl.getBoundingClientRect();
      this._pastColorAnchor = rect.top < window.innerHeight * 0.5;
    }

    _isMobileColorGate() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 1023px)').matches);
    }

    _initFooterObserver() {
      if (typeof IntersectionObserver === 'undefined') return;

      var footer = document.querySelector(
        '[id*="footer-group"], [id*="__footer"], .dd-footer-section, .dd-footer, footer, .footer'
      );
      if (!footer) return;

      var self = this;
      this._footerIo = new IntersectionObserver(
        function(entries) {
          self._footerVisible = entries[0].isIntersecting;
          self._applyStickyVisibility();
        },
        { threshold: 0, rootMargin: '150px 0px 0px 0px' }
      );
      this._footerIo.observe(footer);
    }

    _getMainAtcElement() {
      return this.getMainSubmitButton() || document.querySelector('form[action*="/cart/add"] [name="add"]');
    }

    _sampleMainAtcVisibility() {
      var atcBtn = this._getMainAtcElement();
      if (!atcBtn) {
        this._mainAtcVisible = false;
        return;
      }
      var rect = atcBtn.getBoundingClientRect();
      var hasBox = rect.width > 0 && rect.height > 0;
      this._mainAtcVisible = hasBox && rect.bottom > 0 && rect.top < window.innerHeight;
    }

    _refreshMainAtcObserver() {
      if (this._mainAtcIo) {
        this._mainAtcIo.disconnect();
        this._mainAtcIo = null;
      }

      var atcBtn = this._getMainAtcElement();
      if (!atcBtn || typeof IntersectionObserver === 'undefined') {
        this._sampleMainAtcVisibility();
        this.bindFormQtySync();
        if (this.qtyValueEl) this._swapNumber(this.qtyValueEl, this.getFormQuantity());
        this._applyStickyVisibility();
        return;
      }

      this._mainAtcIo = new IntersectionObserver(
        (entries) => {
          this._mainAtcVisible = entries[0].isIntersecting;
          this._applyStickyVisibility();
        },
        { threshold: 0 }
      );
      this._mainAtcIo.observe(atcBtn);
      this.bindFormQtySync();
      if (this.qtyValueEl) this._swapNumber(this.qtyValueEl, this.getFormQuantity());
    }

    _applyStickyVisibility() {
      var chatActive = document.documentElement.classList.contains('dd-chat-active');
      if (chatActive !== this._chatOpen) this._chatOpen = chatActive;

      // Keep sticky footer state independent from chat-open state. The chat
      // scrim now handles focus management, so hiding/repositioning sticky UI
      // during chat open causes unnecessary layout/animation churn.
      // `_pastColorAnchor` is mobile-only and defaults true elsewhere — see
      // `_sampleColorAnchor()` for the gate semantics. `_mainAtcVisible`
      // is intentionally NOT in the show condition: the sticky now stays
      // up while the inline ATC is visible (we only hide on footer-in-view).
      // The IntersectionObserver on the inline ATC is still wired because
      // its refresh hook (`_refreshMainAtcObserver`) re-binds the qty
      // stepper after the form is replaced on variant change.
      var show =
        this._pastThreshold &&
        this._pastColorAnchor &&
        !this._footerVisible;
      var isCurrentlyVisible = this.classList.contains('is--visible');
      var isExiting = this.classList.contains('is--exiting');

      if (show && !isCurrentlyVisible && !isExiting) {
        // Show: add is--visible
        this.classList.add('is--visible');
        document.documentElement.classList.add('dd-sticky-footer-active');
        this._publishStickyHeight();
        // The server-rendered <video autoplay muted playsinline> inside
        // .dd-sticky-footer__swatch-preview was parsed while the host was
        // `display: none !important` (see dd-pdp-sticky-atc.css). Chromium
        // and WebKit consume the `autoplay` attribute at parse time against
        // the initial layout and won't re-fire it when the ancestor later
        // flips to `display: block` — so the clip sits paused on the poster
        // frame until the shopper interacts. For logged-in customers this
        // was masked by the first variant:change running the JS path
        // (updateSwatchPreview → _renderSwatchVideo → video.play()). Guests
        // on non-gated PDPs don't get that path (no product-form hydrate,
        // ATC replaced with login), so autoplay never got kicked. Explicit
        // .play() here fixes both states idempotently.
        this._kickSwatchPreviewVideo();
      } else if (!show && isCurrentlyVisible && !isExiting) {
        // Hide: trigger exit animation
        this.classList.add('is--exiting');
        document.documentElement.classList.remove('dd-sticky-footer-active');
        this._clearStickyHeight();

        // After animation completes, remove classes. Two guards:
        //   1. `e.target !== self` — bubbled events from descendant
        //      animations (dd-sf-swap-in, dd-sf-tick-*, dd-sf-bump,
        //      dd-sf-atc-success, stock pill pulses etc.) would otherwise
        //      strip `is--visible` mid-exit and the footer would vanish /
        //      refuse to re-show until the next full scroll cycle.
        //   2. `animationName` — belt-and-suspenders in case the host
        //      itself ever picks up a second animation.
        //
        // The 400ms fallback also guards against re-entry: if the shopper
        // scrolls back down mid-exit and we've already cleared the exit,
        // `is--exiting` will be gone and we must NOT strip `is--visible`.
        var self = this;
        var cleanup = function() {
          self.removeEventListener('animationend', onAnimEnd);
          if (self._stickyExitFallback) {
            clearTimeout(self._stickyExitFallback);
            self._stickyExitFallback = 0;
          }
        };
        var onAnimEnd = function(e) {
          if (e && e.target !== self) return;
          if (e && e.animationName && e.animationName !== 'stickyFooterOut') return;
          if (!self.classList.contains('is--exiting')) { cleanup(); return; }
          self.classList.remove('is--visible', 'is--exiting');
          cleanup();
        };
        this.addEventListener('animationend', onAnimEnd);

        if (this._stickyExitFallback) clearTimeout(this._stickyExitFallback);
        this._stickyExitFallback = setTimeout(function() {
          self._stickyExitFallback = 0;
          // Only clean up if we're STILL in the exit phase — otherwise the
          // shopper scrolled back down and the show path already re-armed
          // `is--visible`; stripping it would hide the footer uselessly.
          if (!self.classList.contains('is--exiting')) { cleanup(); return; }
          self.classList.remove('is--visible', 'is--exiting');
          cleanup();
        }, 400);
      } else if (show && isCurrentlyVisible && isExiting) {
        // Shopper scrolled back into the show zone while we were animating
        // out. Cancel the exit so the footer stays put instead of briefly
        // disappearing. The 400ms fallback above checks `is--exiting`
        // before clobbering, so this is safe.
        this.classList.remove('is--exiting');
        document.documentElement.classList.add('dd-sticky-footer-active');
        this._publishStickyHeight();
      }
    }

    bindChatCoordination() {
      this._onChatToggle = (event) => {
        this._chatOpen = !!(event && event.detail && event.detail.open);
        this._applyStickyVisibility();
      };

      document.addEventListener('dd:chat:toggle', this._onChatToggle);
      this._applyStickyVisibility();
    }

    _syncInfoColumnGeometry() {
      /* Event seat PDP: pin to viewport, not the narrowed buy-box column. */
      if (this.classList.contains('dd-sticky-footer--event')) {
        this.style.removeProperty('--dd-sf-atc-w');
        this.style.removeProperty('--dd-sf-atc-right');
        return;
      }

      var id = this.infoDomId || (this.sectionId ? 'ProductInfo-' + this.sectionId : '');
      var info =
        (id && document.getElementById(id)) ||
        document.querySelector('product-info .product__info-container');
      var sw = document.querySelector('product-info dd-swatch-selector');
      var grid = document.querySelector('product-info .product--gallery');

      // No-media PDPs (e.g. the event seat) render a single centered
      // column, so anchoring the card under that column parks it
      // mid-viewport. Fall back to the stylesheet defaults: standard
      // width, pinned bottom-right like every other PDP.
      if (grid && grid.classList.contains('product--no-media')) {
        this.style.removeProperty('--dd-sf-atc-w');
        this.style.removeProperty('--dd-sf-atc-right');
        return;
      }

      var left = Infinity;
      var right = 0;
      var found = false;

      [info, sw].forEach(function (el) {
        if (!el) return;
        var b = el.getBoundingClientRect();
        if (b.width < 8 || b.height < 8) return;
        found = true;
        left = Math.min(left, b.left);
        right = Math.max(right, b.right);
      });

      if (!found || !isFinite(left)) {
        this.style.removeProperty('--dd-sf-atc-w');
        this.style.removeProperty('--dd-sf-atc-right');
        return;
      }

      var w = Math.round(right - left);

      if (grid && window.matchMedia('(min-width: 1024px)').matches) {
        var gr = grid.getBoundingClientRect();
        if (gr.width > 200) {
          var cs = window.getComputedStyle(grid);
          var gapPx = 32;
          var cg = cs.columnGap || cs.gap || '';
          if (cg) {
            var parsed = parseFloat(cg);
            if (!isNaN(parsed)) {
              if (cg.indexOf('rem') !== -1) {
                var rootFs = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
                gapPx = parsed * rootFs;
              } else {
                gapPx = parsed;
              }
            }
          }
          var colFromGrid = (gr.width - gapPx) * (GRID_COL_FR_RIGHT / GRID_COL_FR_TOTAL);
          w = Math.max(w, Math.round(colFromGrid));
        }
      }

      w = Math.max(MIN_STICKY_W, w);
      w = Math.min(w, Math.round(window.innerWidth - 16));

      var anchorRight = right;
      var colLeft = left;
      if (info) {
        var ir = info.getBoundingClientRect();
        if (ir.width >= 8 && ir.height >= 8) {
          anchorRight = ir.right;
          colLeft = ir.left;
        }
      }
      var maxWInColumn = Math.round(anchorRight - colLeft - 4);
      if (maxWInColumn >= MIN_STICKY_W) w = Math.min(w, maxWInColumn);

      var rightInset = Math.max(8, Math.round(window.innerWidth - anchorRight));
      this.style.setProperty('--dd-sf-atc-w', w + 'px');
      this.style.setProperty('--dd-sf-atc-right', rightInset + 'px');
    }

    bindPillScroll() {
      if (!this.pillsContainer) return;
      this.pillsContainer.addEventListener('click', (e) => {
        var pill = e.target.closest('[data-dd-sf-pill]');
        if (!pill) return;
        var name = pill.dataset.ddSfPill;
        if (!name) return;
        this.scrollToOptionGroup(name);
      });
    }

    scrollToOptionGroup(optionName) {
      var swatchRoot =
        document.getElementById('dd-pdp-swatch-section-' + this.sectionId) ||
        document.querySelector('dd-swatch-selector');
      var group = null;
      if (swatchRoot) {
        swatchRoot.querySelectorAll('[data-dd-option-group]').forEach(function (g) {
          if (group) return;
          if (g.getAttribute('data-option-name') === optionName) group = g;
        });
      }
      var el = group || swatchRoot || document.getElementById('ProductInfo-' + this.sectionId);
      if (!el) return;

      var top = el.getBoundingClientRect().top + window.scrollY - SCROLL_TO_OFFSET;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    bindClick() {
      if (!this.button) return;

      this.button.addEventListener('click', (e) => {
        if (this.button.tagName === 'A') return;
        e.preventDefault();

        if (this.isGuest) {
          var drawer = document.querySelector('login-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(this.button);
          } else {
            var loginLink = this.querySelector('.dd-sticky-footer__atc--login');
            window.location.href = loginLink ? loginLink.href : '/account/login';
          }
          return;
        }

        // Availability-only mode (current variant OOS but other lengths
        // exist): button reads "Available in X, Y, Z…" and is intentionally
        // not `disabled`. Click bounces the user up to the Length chooser
        // so they can pick a buyable variant instead of submitting a
        // dead-on-arrival ATC. See `syncButtonFromRenderedHtml` for the
        // mode toggle.
        if (this.button.classList.contains('is--availability-only')) {
          this.scrollToOptionGroup('Length');
          return;
        }

        if (this.isAdding || this.button.disabled) return;

        var variantId = this.currentVariantId || this.getVariantIdFromForm();
        if (!variantId) return;

        var qty = this.getFormQuantity();
        this.addToCart(variantId, qty);
      });
    }

    getFormQuantity() {
      var input = this.getQuantityInput();
      if (!input) return 1;
      var n = parseInt(input.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    /*
      Recompute the displayed price as `unit × qty`. Called on:
        - initial connect (so qty > 1 from a stale form is honored)
        - every qty input event (stepper, manual edit, [Use N] click)
        - every variant change (after `_unitPriceCents` is updated)

      Guests don't see pricing (CSS hides the price wrap); we still
      run the math harmlessly so the value is correct if/when the
      price element becomes visible later. The discount-pill JS owns
      its own sale/compare line via `[data-dd-pill-sale]`.
    */
    _renderTotalPrice() {
      if (!this.priceEl) return;
      if (this._unitPriceCents == null) return;
      var qty = this.getFormQuantity ? this.getFormQuantity() : 1;
      var total = this._unitPriceCents * qty;
      this._swapText(this.priceEl, formatMoneyPlain(total));
      this._renderTrialPill(total);
    }

    /*
      First-order trial pill recalc: sale = total minus the offer percent,
      compare = the undiscounted total (strikethrough). Rides the same
      call sites as `_renderTotalPrice` so the pair can never drift from
      the qty x variant total it annotates.
    */
    _renderTrialPill(totalCents) {
      if (!this.trialPill || this._trialPercent == null) return;
      var sale = Math.round((totalCents * (100 - this._trialPercent)) / 100);
      if (this.trialSaleEl) this._swapText(this.trialSaleEl, formatMoneyPlain(sale));
      if (this.trialCompareEl) this._swapText(this.trialCompareEl, formatMoneyPlain(totalCents));
    }

    /*
      The PDP trial card (snippets/dd-pricing-trial-offer.liquid) records
      its auto-apply click in sessionStorage. When that breadcrumb is
      present, the pill's label flips from the offer wording to the
      "applied" confirmation so the two surfaces tell one story.
    */
    _syncTrialAppliedLabel() {
      if (!this.trialPill) return;
      var applied = false;
      try {
        applied = sessionStorage.getItem('dd_trial_discount_applied') === '1';
      } catch (e) {
        applied = false;
      }
      if (!applied) return;
      var defaultLabel = this.trialPill.querySelector('[data-dd-sf-trial-label-default]');
      var appliedLabel = this.trialPill.querySelector('[data-dd-sf-trial-label-applied]');
      if (defaultLabel) defaultLabel.hidden = true;
      if (appliedLabel) appliedLabel.hidden = false;
    }

    bindQty() {
      if (!this.qtyWrap || this.isGuest) return;
      var minus = this.qtyWrap.querySelector('[data-dd-sf-qty-minus]');
      var plus = this.qtyWrap.querySelector('[data-dd-sf-qty-plus]');
      if (minus) {
        minus.addEventListener('click', () => this.adjustFormQuantity(-1));
      }
      if (plus) {
        plus.addEventListener('click', () => this.adjustFormQuantity(1));
      }
    }

    bindFormQtySync() {
      if (this.isGuest) return;
      var input = this.getQuantityInput();

      if (this._boundQtyInput && this._boundQtyInput !== input && this._onBoundQtySync) {
        this._boundQtyInput.removeEventListener('input', this._onBoundQtySync);
        this._boundQtyInput.removeEventListener('change', this._onBoundQtySync);
      }

      if (!input || !this.qtyValueEl) {
        this._boundQtyInput = null;
        return;
      }

      if (this._boundQtyInput === input && this._onBoundQtySync) {
        this._onBoundQtySync();
        return;
      }

      this._onBoundQtySync = () => {
        this._swapNumber(this.qtyValueEl, this.getFormQuantity());
        this._renderTotalPrice();
        this.refreshBundleChip();
      };
      this._boundQtyInput = input;
      input.addEventListener('input', this._onBoundQtySync);
      input.addEventListener('change', this._onBoundQtySync);
      this._onBoundQtySync();
    }

    adjustFormQuantity(delta) {
      var input = this.getQuantityInput();
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;
      var v = parseInt(input.value, 10) || min;
      v += delta;
      if (v < min) v = min;
      if (max != null && !isNaN(max) && max > 0 && v > max) v = max;
      input.value = String(v);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (this.qtyValueEl) this._swapNumber(this.qtyValueEl, v);
    }

    /*
      Resolve the currently-selected length value for the bundle-chip
      lookup. Strategy: prefer the dd-swatch-selector's `selectedValues`
      (server-of-truth client side; updates synchronously on click),
      fall back to reading the variant's options array using the option
      position emitted by Liquid on this element.
    */
    getCurrentLengthValue(variant) {
      var swatch = document.querySelector('dd-swatch-selector');
      if (swatch && swatch.selectedValues) {
        var keys = Object.keys(swatch.selectedValues);
        for (var i = 0; i < keys.length; i++) {
          if (/length|inch/i.test(keys[i])) return swatch.selectedValues[keys[i]] || '';
        }
      }
      var pos = parseInt(this.dataset.lengthOptionPosition, 10);
      if (variant && variant.options && pos > 0 && variant.options.length >= pos) {
        return variant.options[pos - 1] || '';
      }
      return '';
    }

    getBundleRecommendation(value) {
      var handle = this.dataset.productHandle || '';
      var swatch = document.querySelector('dd-swatch-selector');
      var ctor = swatch && swatch.constructor;
      if (ctor && typeof ctor.getBundleRecommendation === 'function') {
        return ctor.getBundleRecommendation(value, handle);
      }
      /* Fallback for the brief window when dd-swatch-selector hasn't
         loaded yet. Generic weft heuristic — DO NOT add per-product
         logic here; the canonical lookup lives on dd-swatch-selector. */
      if (value === undefined || value === null || value === '') return null;
      var clean = String(value).replace(/"/g, '').replace(/inches/gi, '').replace(/inch/gi, '').trim();
      var num = parseFloat(clean);
      if (!isFinite(num) || num <= 0) return null;
      if (num >= 26) return { target: 3, label: '3', unit: 'bundles', phrase: 'for full transformation', caption: '3 bundles for full transformation' };
      if (num >= 22) return { target: 2, label: '2', unit: 'bundles', phrase: 'for full coverage',       caption: '2 bundles for full coverage' };
      if (num <= 20) return { target: 1, label: '1', unit: 'bundles', phrase: 'for fill or natural enhancement', caption: '1 bundle for fill or natural enhancement' };
      return null;
    }

    /*
      Update the bundle-recommendation chip in the sticky footer.
      Called from:
        - connectedCallback (initial render)
        - variantChange (length may have changed)
        - _onBoundQtySync (qty changed)

      Two visibility modes, keyed off [data-dd-sf-disclosure] on the row:

      Disclosure (logged-in pros): the row starts collapsed and the
      chat-row pills own open/closed + which face shows. This refresh
      only updates CONTENT and pill availability:
        - profit face re-priced on every call (rec-independent)
        - no rec at this length: qty pill hides; if its face was open,
          the panel closes (profit pill keeps working)
        - qty at/past target: the Use-N CTA hides, caption stays

      Auto (guests, color-ring): legacy behavior — chip shows/hides
      itself. No profit line exists, so at-or-past-target hides the
      whole row.
    */
    refreshBundleChip(variant) {
      var row = this.querySelector('[data-dd-sf-bundle-row]');
      if (!row) return;
      var chip = row.querySelector('[data-dd-bundle-hint]');
      if (!chip) return;

      /* Don't fight an in-flight collapse animation. The animation
         set _bundleCollapsing on this element; refreshBundleChip is
         called again from _onBoundQtySync the moment qty bumps,
         which would otherwise yank the chip out from under the
         user before the slide-down completes. */
      if (this._bundleCollapsing) return;

      var disclosure = row.hasAttribute('data-dd-sf-disclosure');
      var length = this.getCurrentLengthValue(variant);
      var rec = this.getBundleRecommendation(length);
      var currentQty = this.getFormQuantity ? this.getFormQuantity() : 1;
      var qtyPill = this.querySelector('[data-dd-sf-pill="qty"]');

      /* Disclosure: the profit face prices from the variant alone —
         keep it fresh on every refresh, rec or not. */
      if (disclosure) this._renderBundleProfit(chip, variant, rec || {}, currentQty);

      if (!rec || rec.target <= 1) {
        chip.setAttribute('data-dd-bundle-target', '0');
        if (!disclosure) {
          this._hideBundleRowImmediate(row, chip);
          return;
        }
        if (qtyPill) qtyPill.hidden = true;
        if (this._bundlePanelFace === 'qty') this._closeBundlePanel({ force: true });
        return;
      }

      /* Content refresh — shared by both modes. */
      chip.setAttribute('data-dd-bundle-target', String(rec.target));
      chip.setAttribute('data-dd-bundle-label', rec.label);
      if (rec.unit) chip.setAttribute('data-dd-bundle-unit', rec.unit);
      chip.setAttribute('data-dd-bundle-caption', rec.caption);

      var labelStrong = chip.querySelector('[data-dd-bundle-chip-label]');
      if (labelStrong) labelStrong.textContent = rec.label;

      var captionEl = chip.querySelector('[data-dd-bundle-chip-caption]');
      if (captionEl) {
        var unitFragment = rec.unit ? ' ' + rec.unit : '';
        captionEl.innerHTML = 'Most artists use <strong data-dd-bundle-chip-label>'
          + rec.label + '</strong>' + unitFragment + ' at this length ' + rec.phrase;
      }

      var ctaBtn = chip.querySelector('[data-dd-bundle-apply]');
      if (ctaBtn) {
        ctaBtn.setAttribute('data-dd-bundle-target', String(rec.target));
        ctaBtn.setAttribute('aria-label', 'Set quantity to ' + rec.target);
        var ctaCount = ctaBtn.querySelector('[data-dd-bundle-cta-count]');
        if (ctaCount) ctaCount.textContent = String(rec.target);
      }

      /* One impression per page load: "a usable rec surfaced" (pill
         available / chip rendered). Variant flips re-enter this path;
         only the first counts, keeping impressions comparable to page
         views. */
      if (!this._bundleImpressionTracked) {
        this._bundleImpressionTracked = true;
        this._trackBundleEvent('bundle_rec_impression', 'Bundle Rec Viewed', {
          rec_target: rec.target,
          rec_label: rec.label,
          length: String(length || ''),
        });
      }

      if (disclosure) {
        if (qtyPill) qtyPill.hidden = false;
        var recRowD = chip.querySelector('[data-dd-bundle-rec]');
        if (recRowD) recRowD.hidden = false;
        /* At/past target there's nothing to apply — the caption keeps
           explaining the rec, only the CTA retires. */
        if (ctaBtn) ctaBtn.hidden = currentQty >= rec.target;
        return;
      }

      /* ── Auto mode (guests) from here down. ── */
      if (currentQty >= rec.target) {
        var profitEl = chip.querySelector('[data-dd-bundle-profit]');
        if (!profitEl) {
          this._hideBundleRowImmediate(row, chip);
          return;
        }
        chip.hidden = false;
        row.hidden = false;
        row.classList.remove('is--collapsing');
        var recRowMet = chip.querySelector('[data-dd-bundle-rec]');
        if (recRowMet) recRowMet.hidden = true;
        this._renderBundleProfit(chip, variant, rec, currentQty);
        return;
      }

      /* Show / refresh visibility. */
      chip.hidden = false;
      row.hidden = false;
      row.classList.remove('is--collapsing');
      var recRow = chip.querySelector('[data-dd-bundle-rec]');
      if (recRow) recRow.hidden = false;
      if (ctaBtn) ctaBtn.hidden = false;

      /* Expected-profit top line. Node only exists for logged-in
         customers (Liquid-gated in dd-bundle-recommendation.liquid).

         Hair profit: 100% hair markup store-wide, so per-unit profit =
         the pro price itself. Variant calls re-derive it and persist it
         on data-profit-cents; qty-sync calls pass no variant and reuse
         the stored value.

         Install fee (merchant-specified, encoded by Liquid):
           data-fee-model "rows": $fee per row, 1-2 units fit one row,
             3+ units = 2 rows, NEVER 3 rows (SuperWeft + generic wefts)
           data-fee-model "unit": $fee per unit installed
             (Keratin Tips $100/box, SecreTapes $50/bundle)

         Display is qty-aware so stylists never multiply:
           qty 1:  "Expected profit: $189 per bundle (+$100 install fee)"
           qty 2:  "Expected profit: $378 (2 x $189/bundle) (+$100 install fee)"
         (At qty >= rec.target the rec row hides but the profit line
         stays, so the multiplied face keeps rendering.) */
      this._renderBundleProfit(chip, variant, rec, currentQty);
    }

    /* Re-renders the expected-profit line. Shared by both chip faces:
       the full rec face (qty below target) and the profit-only face
       (qty at/past target, rec row hidden). No-op when the profit node
       is absent (guests). */
    _renderBundleProfit(chip, variant, rec, currentQty) {
      var profitRoot = chip.querySelector('[data-dd-bundle-profit]');
      if (!profitRoot) return;

      var profitUnitEl = profitRoot.querySelector('[data-dd-bundle-profit-unit]');
      if (variant && typeof variant.price === 'number') {
        if (variant.price > 0) {
          profitRoot.setAttribute('data-profit-cents', String(variant.price));
        }
        if (profitUnitEl && rec.unit) {
          profitUnitEl.textContent = String(rec.unit).replace(/s$/, '');
        }
      }

      var unitProfit = parseInt(profitRoot.getAttribute('data-profit-cents'), 10);
      var feeModel = profitRoot.getAttribute('data-fee-model') || 'unit';
      var unitFee = parseInt(profitRoot.getAttribute('data-fee-cents'), 10) || 0;
      var profitAmountEl = profitRoot.querySelector('[data-dd-bundle-profit-amount]');
      var profitPerEl = profitRoot.querySelector('[data-dd-bundle-profit-per]');
      var feeAmountEl = profitRoot.querySelector('[data-dd-bundle-profit-fee-amount]');
      var profitQty = Math.max(1, currentQty || 1);
      var feeTotal =
        feeModel === 'rows' ? (profitQty <= 2 ? 1 : 2) * unitFee : profitQty * unitFee;

      if (profitAmountEl && isFinite(unitProfit) && unitProfit > 0) {
        if (profitQty > 1) {
          profitAmountEl.textContent = formatMoneyPlain(unitProfit * profitQty);
          if (profitPerEl) profitPerEl.hidden = true;
        } else {
          profitAmountEl.textContent = formatMoneyPlain(unitProfit);
          if (profitPerEl) profitPerEl.hidden = false;
        }
        if (feeAmountEl) feeAmountEl.textContent = '+' + formatMoneyPlain(feeTotal);
      }
    }

    _hideBundleRowImmediate(row, chip) {
      row.classList.remove('is--collapsing');
      chip.hidden = true;
      row.hidden = true;
    }

    /*
      Usage analytics for the bundle-recommendation chip. The chip sits
      in premium sticky-footer real estate; these events exist to answer
      "does anyone actually use it?" before investing more design effort.
      Two fire-and-forget rails, each wrapped so analytics can never
      break the footer:
        - window.dataLayer (GTM/GA4): same rail as
          back_in_stock_subscribed in dd-notify-when-available.js
        - Klaviyo onsite (window.klaviyo, legacy window._learnq) when
          present: ties the event to the logged-in pro's profile
    */
    _trackBundleEvent(dlEvent, kvMetric, props) {
      var payload = Object.assign(
        {
          product_handle: this.dataset.productHandle || '',
          audience: this.isGuest ? 'guest' : 'pro',
        },
        props || {}
      );
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: dlEvent }, payload));
      } catch (err) {
        /* no-op */
      }
      try {
        var kv = window.klaviyo || window._learnq;
        if (kv && typeof kv.push === 'function') kv.push(['track', kvMetric, payload]);
      } catch (err) {
        /* no-op */
      }
    }

    /*
      User-initiated collapse — slides the chip down to baseline mask
      then hides the row. Triggered exclusively by the [Use N] CTA so
      the dismissal feels intentional. refreshBundleChip's own hide
      path uses `_hideBundleRowImmediate` (no animation) for variant
      switches and qty edits via the stepper.
    */
    _collapseBundleRowAnimated(row, chip) {
      if (!row || !chip) return;
      if (this._bundleCollapsing) return;
      this._bundleCollapsing = true;
      row.classList.add('is--collapsing');

      var done = false;
      var finish = () => {
        if (done) return;
        done = true;
        row.removeEventListener('transitionend', onEnd);
        chip.hidden = true;
        row.hidden = true;
        row.classList.remove('is--collapsing');
        this._bundleCollapsing = false;
        /* If the user changed length mid-animation, refreshBundleChip
           was suppressed (collapsing flag). Re-evaluate now so the
           chip catches up to the post-animation variant + qty state. */
        Promise.resolve().then(() => this.refreshBundleChip());
      };
      var onEnd = (e) => {
        /* Wait for the row's max-height transition (the longest of
           the chip animations) — ignore inner transitions. */
        if (e.target !== row) return;
        if (e.propertyName !== 'max-height') return;
        finish();
      };
      row.addEventListener('transitionend', onEnd);
      /* Belt-and-suspenders fallback for browsers that drop the event
         (e.g. when reduced motion suppresses transitions). */
      window.setTimeout(finish, 480);
    }

    bindBundleApply() {
      if (this.isGuest) return;
      var row = this.querySelector('[data-dd-sf-bundle-row]');
      if (!row) return;
      if (row._ddBundleApplyBound) return;
      row._ddBundleApplyBound = true;

      row.addEventListener('click', (e) => {
        var btn = e.target && e.target.closest ? e.target.closest('[data-dd-bundle-apply]') : null;
        if (!btn) return;
        e.preventDefault();
        var target = parseInt(btn.getAttribute('data-dd-bundle-target'), 10);
        if (!isFinite(target) || target <= 0) return;
        var current = this.getFormQuantity ? this.getFormQuantity() : 1;
        var delta = target - current;
        var chip = row.querySelector('[data-dd-bundle-hint]');

        this._trackBundleEvent('bundle_rec_use_click', 'Bundle Rec CTA Clicked', {
          rec_target: target,
          qty_before: current,
          length: String(this.getCurrentLengthValue() || ''),
        });

        /* Pros (profit line present): the chip survives the click —
           qty-sync's refreshBundleChip swaps it to the profit-only
           face (rec row hidden, multiplied total shown). Only guests
           get the whole-row slide-away, since their chip would be an
           empty box once the rec row hides. */
        var hasProfitLine = chip && chip.querySelector('[data-dd-bundle-profit]');
        if (!hasProfitLine) {
          /* Start the collapse animation BEFORE bumping qty. The flag
             set inside `_collapseBundleRowAnimated` makes the qty-sync
             callback skip its own hide path so the animation isn't
             pre-empted. */
          this._collapseBundleRowAnimated(row, chip);
        }

        if (delta !== 0) {
          try {
            this.adjustFormQuantity(delta);
          } catch (err) {
            console.warn('[dd-sticky-footer] bundle-apply failed', err);
          }
        }

        /* Disclosure panel (pros): the tap did its job — tuck the
           panel away so the qty stepper's bump is the feedback. */
        if (row.hasAttribute('data-dd-sf-disclosure')) {
          this._closeBundlePanel({ force: true });
        }
      });
    }

    /*
      Chat-row pills (logged-in pros): [How many bundles?]
      [Expected profit] [Chat with support].

      The first two expand the bundle-row panel above the chat row —
      the SAME [data-dd-sf-collapsible] max-height machinery the
      footer's drag-collapse rides — and swap which chip face shows
      (.dd-bundle-chip--face-qty / --face-profit).

      Desktop (hover: fine): hover a qty/profit pill to preview the
      panel; leaving the pill+panel zone collapses unless click-pinned.
      Click pins the face (click again to unpin and close). Mobile stays
      click/tap-only.

      The chat pill is NOT handled here beyond analytics: theme.liquid's
      [data-dd-open-chat] document delegate owns the action, so no
      preventDefault on that path.
    */
    bindBundlePills() {
      var pillRow = this.querySelector('[data-dd-sf-pill-row]');
      if (!pillRow) return;
      if (pillRow._ddBundlePillsBound) return;
      pillRow._ddBundlePillsBound = true;

      var self = this;
      var bundleRow = this.querySelector('[data-dd-sf-bundle-row][data-dd-sf-disclosure]');
      var hoverZoneNodes = bundleRow ? [pillRow, bundleRow] : [];

      function isBundleFace(face) {
        return face === 'qty' || face === 'profit';
      }

      function isHoverCapable() {
        try {
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        } catch (err) {
          return false;
        }
      }

      function isInHoverZone(node) {
        if (!node) return false;
        for (var i = 0; i < hoverZoneNodes.length; i++) {
          if (hoverZoneNodes[i].contains(node)) return true;
        }
        return false;
      }

      /* Chat uses class dd-sf-pill but not data-dd-sf-pill — resolve by
         class so profit→chat hover exit actually fires. */
      function resolvePillRowPill(target) {
        if (!target || !target.closest) return null;
        var pill = target.closest('.dd-sf-pill');
        if (!pill || !pillRow.contains(pill)) return null;
        return pill;
      }

      pillRow.addEventListener('click', function (e) {
        var target = e.target || null;
        if (target && target.closest && target.closest('[data-dd-open-chat]')) {
          self._trackBundleEvent('bundle_pill_open', 'Bundle Pill Opened', { pill: 'chat' });
          return;
        }
        var pill = target && target.closest ? target.closest('[data-dd-sf-pill]') : null;
        if (!pill) return;
        e.preventDefault();
        self._toggleBundlePanelOnClick(pill.getAttribute('data-dd-sf-pill'));
      });

      function onChatPillEnter() {
        if (!isHoverCapable()) return;
        /* Chat is outside the bundle preview — always collapse on entry. */
        self._closeBundlePanel({ force: true });
      }

      var chatPill = pillRow.querySelector('[data-dd-open-chat].dd-sf-pill');
      if (chatPill) {
        chatPill.addEventListener('mouseenter', onChatPillEnter);
      }

      pillRow.addEventListener('mouseover', function (e) {
        if (!isHoverCapable()) return;
        var pill = resolvePillRowPill(e.target);
        if (!pill) return;
        if (pill.contains(e.relatedTarget)) return;
        if (pill.hasAttribute('data-dd-open-chat')) {
          onChatPillEnter();
          return;
        }
        var face = pill.getAttribute('data-dd-sf-pill');
        if (isBundleFace(face)) {
          self._openBundlePanel(face);
          return;
        }
        self._onBundlePanelHoverExit();
      });

      function onHoverZoneLeave(e) {
        if (!isHoverCapable()) return;
        if (isInHoverZone(e.relatedTarget)) return;
        self._onBundlePanelHoverExit();
      }

      for (var z = 0; z < hoverZoneNodes.length; z++) {
        hoverZoneNodes[z].addEventListener('mouseleave', onHoverZoneLeave);
      }
    }

    _toggleBundlePanelOnClick(face) {
      var row = this.querySelector('[data-dd-sf-bundle-row]');
      if (!row || !face) return;

      if (
        this._bundlePanelPinnedFace === face
        && row.classList.contains('is--open')
        && this._bundlePanelFace === face
      ) {
        this._bundlePanelPinnedFace = null;
        this._closeBundlePanel({ force: true });
        return;
      }

      this._openBundlePanel(face, { track: true });
      this._bundlePanelPinnedFace = face;
    }

    _openBundlePanel(face, opts) {
      opts = opts || {};
      var row = this.querySelector('[data-dd-sf-bundle-row]');
      var chip = row ? row.querySelector('[data-dd-bundle-hint]') : null;
      if (!row || !chip || !face) return;

      /* SSR may have left the chip/row hidden (no-rec placeholder
         markup). The closed panel is masked by max-height: 0, so
         unhiding here is safe — and required for the expand to
         reveal anything. */
      chip.hidden = false;
      row.hidden = false;
      chip.classList.toggle('dd-bundle-chip--face-qty', face === 'qty');
      chip.classList.toggle('dd-bundle-chip--face-profit', face === 'profit');
      row.classList.add('is--open');
      this._bundlePanelFace = face;
      this._syncBundlePillState();
      if (opts.track) {
        this._trackBundleEvent('bundle_pill_open', 'Bundle Pill Opened', { pill: face });
      }
    }

    _onBundlePanelHoverExit() {
      if (this._bundlePanelPinnedFace) {
        if (this._bundlePanelFace !== this._bundlePanelPinnedFace) {
          this._openBundlePanel(this._bundlePanelPinnedFace);
        }
        return;
      }
      this._closeBundlePanel({ force: true });
    }

    _closeBundlePanel(opts) {
      opts = opts || {};
      if (!opts.force && this._bundlePanelPinnedFace) return;

      var row = this.querySelector('[data-dd-sf-bundle-row]');
      if (row) row.classList.remove('is--open');
      this._bundlePanelFace = null;
      if (opts.force) this._bundlePanelPinnedFace = null;
      this._syncBundlePillState();
    }

    /* aria-expanded mirrors which pill's face is showing. */
    _syncBundlePillState() {
      var pills = this.querySelectorAll('[data-dd-sf-pill]');
      for (var i = 0; i < pills.length; i++) {
        var open = this._bundlePanelFace === pills[i].getAttribute('data-dd-sf-pill');
        pills[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    getVariantIdFromForm() {
      var form = this.getProductForm();
      if (!form) return null;
      var inp = form.querySelector('input[name="id"]:not([disabled])') || form.querySelector('input[name="id"]');
      if (!inp) return null;
      var parsed = parseInt(inp.value, 10);
      return isNaN(parsed) ? null : parsed;
    }

    isRateLimitError(err) {
      if (!err) return false;
      var status = Number(err.shopifyStatus || err.status || 0);
      if (status === 429) return true;
      var raw = '';
      if (err.description) raw += String(err.description) + ' ';
      if (err.message) raw += String(err.message);
      return /(^|\b)(1015|429)(\b|$)|rate\s*limit|too\s+many\s+requests/i.test(raw);
    }

    shouldResyncDrawerAfterAddError(err) {
      if (!err) return false;
      var status = Number(
        err.shopifyStatus ||
          err.status ||
          (err.responseBody && err.responseBody.status) ||
          0
      );
      if (status === 422) return true;

      var raw = '';
      if (err.description) raw += String(err.description) + ' ';
      if (err.message) raw += String(err.message);
      raw = raw.replace(/[\u2018\u2019]/g, "'");
      return /\b422\b|cart error|can't add more|cannot add more|cant add more|sold out|out of stock|in your cart/i.test(raw);
    }

    resyncAndOpenDrawer(variantId) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      fetch('/cart?sections=cart-drawer', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (sections) {
          if (typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: sections });
          } else if (typeof drawer.open === 'function') {
            drawer.open();
          }
        })
        .catch(function () {
          if (typeof drawer.open === 'function') drawer.open();
        });
    }

    parseStockConstraintFromAddError(err, requestedQty) {
      var parts = [];
      if (err && err.responseBody) {
        if (err.responseBody.description) parts.push(String(err.responseBody.description));
        if (err.responseBody.message) parts.push(String(err.responseBody.message));
        if (err.responseBody.errors) {
          if (typeof err.responseBody.errors === 'string') {
            parts.push(err.responseBody.errors);
          } else {
            try {
              parts.push(JSON.stringify(err.responseBody.errors));
            } catch (_) {}
          }
        }
      }
      if (err && err.description) parts.push(String(err.description));
      if (err && err.message) parts.push(String(err.message));
      var raw = parts.join(' ').trim();
      var normalizedRaw = raw.replace(/[\u2018\u2019]/g, "'");
      var lowered = normalizedRaw.toLowerCase();

      var soldOut = /\bsold out\b|\bout of stock\b|\bunavailable\b/.test(lowered);
      var alreadyInCart = /\balready in your cart\b|\bare in your cart\b|\bis in your cart\b/.test(lowered);
      var cantAddMore =
        /can't add more|cannot add more|cant add more|can not add more|more than\s+\d+/.test(lowered);

      var explicitAllowed = null;

      var patterns = [
        /\bonly\s+(\d+)\s+(?:left|available|remaining)\b/i,
        /\b(\d+)\s+(?:left|available|remaining)\b/i,
        /\bonly\s+add\s+(\d+)\b/i,
        /\byou can only add\s+(\d+)\b/i,
        /\bmore than\s+(\d+)\b/i,
        /\ball\s+(\d+)\s+(?:available|left|remaining|in stock)\b/i,
      ];
      for (var i = 0; i < patterns.length; i++) {
        var m = normalizedRaw.match(patterns[i]);
        if (!m) continue;
        var n = parseInt(m[1], 10);
        if (!isNaN(n) && n >= 0) {
          explicitAllowed = n;
          break;
        }
      }

      var allowedToAddNow = explicitAllowed;
      if (alreadyInCart) {
        allowedToAddNow = 0;
      } else if (
        allowedToAddNow === null &&
        !soldOut &&
        cantAddMore &&
        typeof requestedQty === 'number' &&
        requestedQty > 1
      ) {
        /* Fallback when Shopify only reports "can't add more" without count:
           keep future attempts conservative instead of re-sending an oversized qty. */
        allowedToAddNow = 1;
      }

      return {
        raw: raw,
        soldOut: soldOut,
        alreadyInCart: alreadyInCart,
        cantAddMore: cantAddMore,
        allowedToAddNow: allowedToAddNow,
      };
    }

    setFormQuantity(value) {
      var input = this.getQuantityInput();
      if (!input) return null;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min) || min < 1) min = 1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;
      var next = parseInt(value, 10);
      if (isNaN(next)) next = min;
      if (next < min) next = min;
      if (max != null && !isNaN(max) && max > 0 && next > max) next = max;
      input.value = String(next);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (this.qtyValueEl) this._swapNumber(this.qtyValueEl, next);
      return next;
    }

    addToCart(variantId, quantity) {
      quantity = quantity || 1;
      this.isAdding = true;
      var label = this.atcLabel || this.button;
      var origText = label ? label.textContent : '';
      if (this.button) {
        this.button.classList.remove('is--success');
        this.button.classList.add('is--loading');
      }
      if (label) this._swapText(label, 'Adding…');
      this.button.disabled = true;
      var itemPayload = this.buildAddItemPayload(variantId, quantity);
      var self = this;

      var helpers = window.ddCartHelpers;

      function doRawFetch() {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [itemPayload],
            sections: 'cart-drawer,cart-icon-bubble',
          }),
        }).then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (body) {
              var err = new Error(body.description || 'Cart mutation failed (' + r.status + ')');
              err.description = body.description || '';
              err.shopifyStatus = r.status;
              throw err;
            });
          }
          return r.json();
        });
      }

      function handleSuccess(data) {
        if (self.button) {
          self.button.classList.remove('is--loading');
          self.button.classList.add('is--success');
        }
        if (label) self._swapText(label, 'Added!');

        if (self.isGuestColorRingPurchase) {
          if (self.button) self.button.classList.remove('is--success');
          if (label) self._swapText(label, origText);
          self.button.disabled = false;
          self.isAdding = false;
          window.location.href = self.buildGuestCheckoutUrl();
          return;
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          drawer.renderContents(data);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }

        if (helpers && typeof helpers.publishCartUpdate === 'function') {
          helpers.publishCartUpdate(data, 'sticky-atc');
        }

        setTimeout(function () {
          if (self.button) self.button.classList.remove('is--success');
          if (label) self._swapText(label, origText);
          self.button.disabled = false;
          self.isAdding = false;
        }, 1500);
      }

      function handleError(err) {
        console.error('[dd-sticky-footer] ATC error', err);
        if (self.button) self.button.classList.remove('is--loading', 'is--success');
        if (label) self._swapText(label, origText);
        self.button.disabled = false;
        self.isAdding = false;

        var h = window.ddCartHelpers;
        var parsed = h && h.parseCartStockError(err, { operation: 'add', requestedQty: quantity });
        var stockMsg = parsed && h.stockErrorMessage(parsed, { operation: 'add', requestedQty: quantity });
        var msg = (stockMsg && stockMsg.message) || err.description || 'We couldn\u2019t add that quantity.';
        var toastType = (stockMsg && stockMsg.toastType) || 'error';

        if (parsed && !parsed.rateLimited && (parsed.kind === 'stock' || parsed.staleLine)) {
          self.resyncAndOpenDrawer(variantId);
          var allowed = parsed.allowedQty;
          if (typeof allowed === 'number' && allowed > 0) {
            self.setFormQuantity(allowed);
          } else if (parsed.soldOut || allowed === 0 || parsed.alreadyInCart) {
            self.setFormQuantity(1);
          }
        }

        if (window.ddToast) window.ddToast(msg, { type: toastType });
      }

      /*
        First-order (SALONTRIAL15) auto-apply. When the trial offer is on
        the page (dd-pricing-trial-offer.js publishes window.ddTrialOffer
        only for eligible zero-order customers), make sure the discount
        cookie is set BEFORE the add so the bundled cart-drawer HTML in
        the add response already shows the discounted line. ensureApplied
        never rejects and short-circuits to zero requests once the
        session breadcrumb is set, so this adds at most 1 request to the
        first ATC of the session.
      */
      var trialReady =
        window.ddTrialOffer && typeof window.ddTrialOffer.ensureApplied === 'function'
          ? window.ddTrialOffer.ensureApplied()
          : Promise.resolve(false);

      trialReady.then(function () {
        if (helpers && typeof helpers.enqueueExternalMutation === 'function') {
          return helpers.enqueueExternalMutation({
            label: 'sticky-atc',
            requester: 'dd-sticky-footer',
            endpoint: '/cart/add.js',
            run: doRawFetch,
          }).then(handleSuccess).catch(handleError);
        }
        return doRawFetch().then(handleSuccess).catch(handleError);
      });
    }

    getGuestOfferState() {
      var key = 'dd_color_ring_guest_offer_v1';
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return null;

        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
          localStorage.removeItem(key);
          return null;
        }

        var submittedAt = Number(parsed.submittedAt || 0);
        var expiresAt = Number(parsed.expiresAt || 0);
        var now = Date.now();
        if (!submittedAt || !expiresAt || expiresAt <= now) {
          localStorage.removeItem(key);
          return null;
        }
        return { submittedAt: submittedAt, expiresAt: expiresAt };
      } catch (err) {
        try {
          localStorage.removeItem(key);
        } catch (_) {}
        return null;
      }
    }

    getGuestOfferCodeFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search || '');
        var rawCode = (params.get('dd_offer_code') || '').trim();
        if (!rawCode) return '';
        return rawCode.replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64);
      } catch (_) {
        return '';
      }
    }

    getActiveGuestOfferCode() {
      var urlCode = this.getGuestOfferCodeFromUrl();
      if (urlCode) return urlCode;
      var offer = this.getGuestOfferState();
      if (offer && this.guestDiscountCode) return this.guestDiscountCode;
      return '';
    }

    buildGuestCheckoutUrl() {
      var activeCode = this.getActiveGuestOfferCode();
      if (!activeCode) return '/checkout';
      return '/discount/' + encodeURIComponent(activeCode) + '?redirect=' + encodeURIComponent('/checkout');
    }

    updateGuestOfferRow() {
      // Short-circuit: if NONE of the four surfaces exist (e.g. we're on
      // a non-color-ring PDP where both rows and both pills are skipped
      // server-side), there's nothing to sync.
      var hasAnySurface =
        this.guestOfferRow ||
        this.guestApplyRow ||
        (this.guestDiscountPills && this.guestDiscountPills.length > 0) ||
        this.guestTeaser;
      if (!hasAnySurface) return;

      var urlCode = this.getGuestOfferCodeFromUrl();
      var offer = this.getGuestOfferState();
      var activeCode = urlCode || (offer && this.guestDiscountCode ? this.guestDiscountCode : '');
      // Hours-remaining number is used in two places (sticky offer row +
      // each guest discount pill's countdown). Compute once. Storage-
      // backed offers report the actual hours left so copy stays truthful
      // as the window ticks down; URL-code handoffs have no expiry so we
      // fall back to the configured window from settings.
      var hoursLeft = offer
        ? Math.max(1, Math.ceil((offer.expiresAt - Date.now()) / 3600000))
        : this.guestDiscountHours;

      if (!activeCode) {
        // No discount earned yet → keep offer row hidden, apply row visible.
        // Keep the head/sticky guest pills hidden, keep the teaser visible
        // (guest hasn't applied yet → show them the "Pros save more" nudge),
        // and restore the customer-tier pill to its default (display:none
        // style, since dd-discount-pill.js decides when to reveal it).
        if (this.guestOfferRow) this.guestOfferRow.hidden = true;
        if (this.guestApplyRow) this.guestApplyRow.hidden = false;
        if (this.guestDiscountPills) {
          for (var i = 0; i < this.guestDiscountPills.length; i++) {
            this._hideGuestDiscountPill(this.guestDiscountPills[i]);
          }
        }
        if (this.guestTeaser) this.guestTeaser.hidden = false;
        this._restoreTierPillDefaults();
        return;
      }

      // Discount earned (either via `?dd_offer_code=…` URL handoff or via
      // `dd_color_ring_guest_offer_v1` in localStorage, written by
      // dd-registration-overlay.js when the apply SPA signals success).
      // Flip the full suite of surfaces in lockstep — never show the Apply
      // row or the teaser next to the revealed offer row.
      if (this.guestOfferRow) {
        if (this.guestOfferCodeText) {
          this._swapText(this.guestOfferCodeText, activeCode);
        }
        if (this.guestOfferHoursText) {
          this._swapNumber(this.guestOfferHoursText, hoursLeft);
        }
        this.guestOfferRow.hidden = false;
      }
      if (this.guestApplyRow) this.guestApplyRow.hidden = true;

      if (this.guestDiscountPills) {
        for (var j = 0; j < this.guestDiscountPills.length; j++) {
          this._revealGuestDiscountPill(this.guestDiscountPills[j], activeCode, hoursLeft);
        }
      }
      if (this.guestTeaser) this.guestTeaser.hidden = true;

      // Priority inversion: during an active 48h window the applied pill
      // takes precedence over the customer-tier pill. Hide the tier pills
      // with `!important` via inline style because dd-discount-pill.js
      // may have set its own display style — we need to win regardless of
      // load order.
      this._suppressTierPills();
    }

    /* Reveal a `[data-dd-guest-discount-pill]`. Updates the live code text
       (in case the URL-code override differs from the config), the copy-
       button payload, and the countdown. Operates on a single pill so both
       the head and sticky-footer instances stay in sync. */
    _revealGuestDiscountPill(pill, activeCode, hoursLeft) {
      if (!pill) return;
      var codeEls = pill.querySelectorAll('[data-dd-guest-pill-code]');
      for (var i = 0; i < codeEls.length; i++) this._swapText(codeEls[i], activeCode);

      var hoursEl = pill.querySelector('[data-dd-guest-pill-hours-text]');
      if (hoursEl) this._swapNumber(hoursEl, hoursLeft);

      var copyBtn = pill.querySelector('[data-dd-guest-pill-copy]');
      if (copyBtn) {
        copyBtn.setAttribute('data-dd-guest-pill-copy-code', activeCode);
        copyBtn.setAttribute('aria-label', 'Copy discount code ' + activeCode);
      }

      pill.hidden = false;
      pill.style.display = '';
    }

    _hideGuestDiscountPill(pill) {
      if (!pill) return;
      pill.hidden = true;
      pill.style.display = 'none';
    }

    /* Suppress the customer-tier pill while the color-ring applied pill
       is active. `display: none !important` wins regardless of what
       dd-discount-pill.js has set inline. `_restoreTierPillDefaults()`
       reverses this when the window expires. */
    _suppressTierPills() {
      var marker = 'dd-applied-suppress';
      var apply = function (el) {
        if (!el) return;
        if (el.dataset[marker] === '1') return;
        el.dataset[marker] = '1';
        el.style.setProperty('display', 'none', 'important');
      };
      this.tierPillsHead.forEach(apply);
      apply(this.tierPillFooter);
    }

    _restoreTierPillDefaults() {
      var marker = 'dd-applied-suppress';
      var restore = function (el) {
        if (!el) return;
        if (el.dataset[marker] !== '1') return;
        delete el.dataset[marker];
        // Return to the default hidden state (inline display:none is the
        // server-rendered default; dd-discount-pill.js flips it to empty
        // when a tier matches). Clearing the important flag is enough.
        el.style.removeProperty('display');
        el.style.display = 'none';
      };
      this.tierPillsHead.forEach(restore);
      restore(this.tierPillFooter);
    }

    /* Keep the guest-offer row in sync across the two event sources that
       can flip the applied state while the PDP is open:
         • Same-tab — dd-registration-overlay.js dispatches a `dd:applied`
           CustomEvent on `document` after the apply SPA signals success
           via postMessage. Fires immediately, before the iframe closes.
         • Cross-tab — if the user applies in a second tab, the `storage`
           event fires here with key === 'dd_color_ring_guest_offer_v1'.

       Both just re-run `updateGuestOfferRow()`, which reads the canonical
       localStorage state. Listeners are removed in disconnectedCallback
       so repeated section reloads don't leak handlers. */
    bindAppliedSync() {
      // Nothing to sync if none of the relevant surfaces are in the DOM
      // (e.g. non-color-ring PDP where the offer row, apply row, guest
      // discount pills, and teaser are all skipped server-side).
      var hasAnySurface =
        this.guestOfferRow ||
        this.guestApplyRow ||
        (this.guestDiscountPills && this.guestDiscountPills.length > 0) ||
        this.guestTeaser;
      if (!hasAnySurface) return;

      var self = this;
      this._onAppliedEvent = function () { self.updateGuestOfferRow(); };
      this._onAppliedStorage = function (e) {
        if (!e) return;
        if (e.key !== 'dd_color_ring_guest_offer_v1') return;
        self.updateGuestOfferRow();
      };
      document.addEventListener('dd:applied', this._onAppliedEvent);
      window.addEventListener('storage', this._onAppliedStorage);
    }

    /* Copy-to-clipboard for `[data-dd-guest-pill-copy]`. Delegated at the
       document level because (a) there are two pills on the PDP (head +
       sticky) and (b) installing per-element listeners would leak if the
       sticky footer got torn down + re-created by section reloads. The
       `document._ddGuestPillCopyBound` flag guarantees only one handler
       exists across the lifetime of the page, regardless of how many
       sticky-footer instances have connected. */
    bindGuestPillCopy() {
      if (document._ddGuestPillCopyBound) return;
      document._ddGuestPillCopyBound = true;

      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-dd-guest-pill-copy]');
        if (!btn) return;
        e.preventDefault();

        var code = (btn.getAttribute('data-dd-guest-pill-copy-code') || '').trim();
        if (!code) return;

        var showCopiedState = function () {
          btn.classList.add('is--copied');
          setTimeout(function () {
            btn.classList.remove('is--copied');
          }, 1800);
        };

        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(code).then(showCopiedState, function () {
            // Clipboard API can reject on insecure contexts / permissions —
            // fall through to the execCommand fallback. Don't surface the
            // error to the user; copy UX should stay silent on failure.
            fallbackCopy(code, showCopiedState);
          });
        } else {
          fallbackCopy(code, showCopiedState);
        }
      });

      function fallbackCopy(text, onSuccess) {
        try {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          if (typeof onSuccess === 'function') onSuccess();
        } catch (_) { /* silent */ }
      }
    }

    listenForVariantChanges() {
      if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

      this._variantSubUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        // Ignore renders from other product sections (featured-product
        // blocks etc.). Without this, any section's variantChange would
        // overwrite this footer's variant id with a foreign product's.
        var evtSectionId = event.data?.sectionId;
        if (evtSectionId && this.sectionId && String(evtSectionId) !== String(this.sectionId)) return;

        var variant = event.data?.variant;
        var html = event.data?.html;
        var swatch = document.querySelector('dd-swatch-selector');
        if (swatch) this.syncPills(swatch);
        else if (variant) this.syncPillsFromVariant(variant);

        this._applyVariantState(variant, html);

        // Null variant means no preview refresh is coming (the early
        // return above skips schedulePreviewRefresh), so the pending
        // spinner would only die by failsafe. Settle it now — the
        // stale thumb is the honest face for an unresolvable combo.
        if (!variant) this._setSwatchMediaPending(false);
      });
    }

    /*
      Apply a variant's state to the footer: id, price, ATC button face,
      shipping/custom notices, preview media, qty bindings.

      Called from TWO places with the SAME variant shape (Liquid `variant
      | json`):
        1. The optimistic path (_onSwatchInteract): synchronously on
           swatch selection, using the client-side variantData lookup.
           This is what closes the stale-ATC race: currentVariantId flips
           at the same instant the visible pills do, instead of waiting
           out the Section Rendering API round-trip.
        2. The authoritative path (PUB_SUB_EVENTS.variantChange): after
           the section render lands, with server HTML for exact button
           state. Reconciles anything the optimistic pass got wrong.

      `variant: null` means the current selection resolves to no variant.

      opts.skipPreview: set by the optimistic path. The swatch preview
      thumbnail sources its media from the PDP gallery DOM
      (getFourthGalleryMedia), which only re-renders when the section
      fetch lands. Refreshing it optimistically paints an interim image
      from the OLD gallery and then swaps again on variantChange, i.e. a
      visible double-flash. Price/button/id are variantData-derived and
      safe to flip early; the preview must wait for the render.
    */
    _applyVariantState(variant, html, opts) {
      if (!variant) {
        if (this.button && !this.isGuest) {
          this.button.disabled = true;
          this._setAtcLabel('Select options');
        }
        this.currentVariantId = null;
        this.updateShippingAndCustom(null);
        this.bindFormQtySync();
        return;
      }

      this.currentVariantId = variant.id;

      if (this.priceEl && variant.price != null) {
        this._unitPriceCents = variant.price;
        this.priceEl.setAttribute('data-unit-price', String(variant.price));
        this._renderTotalPrice();
      }

      if (this.button && !this.isGuest) {
        this.syncButtonFromRenderedHtml(html, variant);
      }

      if (!(opts && opts.skipPreview)) this.schedulePreviewRefresh(variant);
      this.updateShippingAndCustom(variant);
      this.bindFormQtySync();
      if (this.qtyValueEl) this._swapNumber(this.qtyValueEl, this.getFormQuantity());
      this.refreshBundleChip(variant);
    }

    syncButtonFromRenderedHtml(html, variant) {
      var serverBtn = html
        ? html.getElementById('ProductSubmitButton-' + this.sectionId)
        : null;

      var isDisabled = serverBtn
        ? serverBtn.hasAttribute('disabled')
        : !variant.available;

      var isCustom = this.isCustomForSticky(variant);

      // Resolve the availability string + combo-unavailable flag up-front
      // so we can pick the right disabled face: combo-unavailable ("Not
      // offered" — brand doesn't produce this color/texture combo, no
      // future restock), availability-only ("Available in 20\", 22\"…"
      // — current variant OOS but the user can pick a buyable length),
      // or plain disabled ("Awaiting Restock" — OOS but expected back).
      var availText = null;
      var isComboUnavailable = false;
      if (isDisabled) {
        var ssEl = document.querySelector('dd-swatch-selector');
        if (ssEl) {
          availText = typeof ssEl.getAvailableLengthsText === 'function'
            ? ssEl.getAvailableLengthsText() : null;
          isComboUnavailable = typeof ssEl.isCurrentComboUnavailable === 'function'
            ? ssEl.isCurrentComboUnavailable() : false;
        }
      }
      // Combo-unavailable supersedes availability-only: even if other
      // lengths technically exist for this color, the current selection
      // is a combo we don't make — bouncing the user to Length wouldn't
      // produce a buyable result for the same texture, and "Not offered"
      // is the truthful surface label.
      var availabilityOnly = isDisabled && !!availText && !isComboUnavailable;

      // In availability-only mode we keep the DOM button *enabled* (so
      // `click` actually fires — disabled buttons don't fire click in any
      // browser), and lean on `aria-disabled` + `is--availability-only`
      // to (a) tell assistive tech the action is unavailable and (b) let
      // CSS render the muted look without `:disabled`. The click handler
      // in `bindClick` short-circuits to a scroll-up.
      if (availabilityOnly) {
        this.button.disabled = false;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('is--availability-only');
      } else {
        this.button.disabled = isDisabled;
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('is--availability-only');
      }

      if (isComboUnavailable) {
        // "Not offered" — brand doesn't produce this color × current
        // length/texture combo. Single short string, no marquee needed.
        this._setAtcLabel('Not offered');
      } else if (isDisabled) {
        // The availability string ("Available in 20\", 22\", 24\"…") is the
        // one label that can realistically overflow the button on narrow
        // viewports — mark it marqueeable so the helper below upgrades it
        // to a scrolling track if the text doesn't fit. The fallback
        // "Awaiting Restock" always fits, so the marquee check no-ops.
        this._setAtcLabel(availText || 'Awaiting Restock', { marqueeable: true });
      } else if (isCustom) {
        this._setAtcLabel(
          this.button.dataset.addCustomText || 'Add item (6-8 weeks)'
        );
      } else {
        this._setAtcLabel(
          this.button.dataset.addText || 'Add to Cart'
        );
      }

      // suppressNotify is the second flag — combo-unavailable products
      // have no future restock signal to subscribe to, so the qty
      // selector AND the notify trigger both stay hidden, leaving just
      // the "Not offered" pill in the slot.
      this.syncQtyVisibility(isDisabled, isComboUnavailable);
    }

    // Smooth-scroll the page so the named PDP option group lands just
    // below the sticky header. Used by the sticky ATC's availability-
    // only state to bounce the user up to the chooser they need to
    // change in order to make the button buyable. Falls back to the
    // <dd-swatch-selector> root if the named group isn't found, so we
    // never just no-op on a click the user explicitly initiated.
    scrollToOptionGroup(optionName) {
      var swatch = document.querySelector('dd-swatch-selector');
      if (!swatch) return;
      var target = null;
      var needle = String(optionName || '').toLowerCase();
      var groups = swatch.querySelectorAll('[data-dd-option-group]');
      for (var i = 0; i < groups.length; i++) {
        var name = (groups[i].dataset.optionName || '').toLowerCase();
        if (needle && name.indexOf(needle) !== -1) {
          target = groups[i];
          break;
        }
      }
      if (!target) target = swatch;

      var headerVal = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var headerH = parseInt(headerVal, 10);
      if (!isFinite(headerH) || headerH < 0) headerH = 0;

      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // The sticky-inline notify host manages its own visibility via
    // PUB_SUB_EVENTS.variantChange — when it shows itself, we hide the qty
    // selector and reveal the "Notify me" trigger so they share the slot.
    // When an in-stock variant is re-selected we restore qty and collapse
    // the panel if it was open.
    //
    // `suppressNotify` (truthy) keeps the notify trigger hidden even on a
    // disabled variant. Used by the "Not offered" branch in
    // syncButtonFromRenderedHtml — there's no future restock to notify
    // about for a color/texture combo the brand doesn't produce, so
    // surfacing a Notify-me pill would be a dead-end UX. In that case
    // both qty AND notify stay hidden and the slot is owned entirely by
    // the disabled "Not offered" ATC label.
    syncQtyVisibility(isDisabled, suppressNotify) {
      var hasStickyNotify = !!this.notifyHost;
      var showNotify = !!(isDisabled && hasStickyNotify && !suppressNotify);

      // qty is hidden when notify is shown (slot share) OR when notify is
      // suppressed because the combo isn't offered — in the second case
      // there's no notify pill to take qty's place, the slot just stays
      // empty and the disabled "Not offered" label owns the row.
      if (this.qtyWrap) this.qtyWrap.hidden = showNotify || !!suppressNotify;
      if (this.notifyTrigger) this.notifyTrigger.hidden = !showNotify;
      if (this.shipNotifyLinks && this.shipNotifyLinks.length) {
        var hideShipNotify = !showNotify
          || !!(this.notifyHost && this.notifyHost.isSubscribed);
        this.shipNotifyLinks.forEach(function (link) {
          link.hidden = hideShipNotify;
        });
      }

      // When notify is no longer needed but the panel is open, collapse it.
      if (!showNotify && this.notifyHost && typeof this.notifyHost.close === 'function') {
        try { this.notifyHost.close(); } catch (_) { /* noop */ }
      }
    }

    schedulePreviewRefresh(variant) {
      if (this._previewRaf) cancelAnimationFrame(this._previewRaf);
      this._previewRaf = requestAnimationFrame(() => {
        this._previewRaf = requestAnimationFrame(() => {
          this._previewRaf = 0;
          this.updateSwatchPreview(variant);
        });
      });
    }

    listenForSwatchChanges() {
      var swatch = document.querySelector('dd-swatch-selector');
      // No pillsContainer is fine: syncPills self-guards, and the
      // optimistic variant resolution below must bind regardless (it's
      // the stale-ATC race fix, not a pills cosmetic).
      if (!swatch) return;

      if (this._swatchRoot && this._swatchRoot !== swatch && this._onSwatchInteract) {
        this._swatchRoot.removeEventListener('click', this._onSwatchInteract);
        this._swatchRoot.removeEventListener('change', this._onSwatchInteract);
      }

      if (this._swatchRoot !== swatch) {
        this._swatchRoot = swatch;
        this._onSwatchInteract = () => {
          /*
            rAF so the swatch selector's own click handler has finished
            committing `selectedValues` before we read it.

            Beyond pill cosmetics, this is the stale-ATC race fix: resolve
            the newly selected variant from the swatch's client-side
            variantData and flip currentVariantId NOW, not after the
            Section Rendering API round-trip. Before this, the footer
            *looked* updated instantly (pills swap on this same event) but
            kept the old variant id for the entire fetch window, so a fast
            ATC tap after a color switch added the previously selected
            variant. variantChange still lands afterwards and reconciles
            with server-rendered truth.
          */
          requestAnimationFrame(() => {
            this.syncPills(swatch);

            /*
              Guard: findVariantFromSelected() skips options with no
              selection, so with a PARTIAL selection it would happily
              "resolve" the first variant that matches the chosen subset.
              On gated no-pick products (nothing selected yet) that would
              enable the ATC with a variant the shopper never chose. Only
              trust the lookup when every option group has a committed
              value; otherwise leave the footer exactly as the server
              rendered it.
            */
            var selectionComplete = true;
            if (swatch.selectedValues) {
              swatch.querySelectorAll('[data-dd-option-group]').forEach(function (g) {
                var optName = g.getAttribute('data-option-name');
                if (optName && !swatch.selectedValues[optName]) selectionComplete = false;
              });
            } else {
              selectionComplete = false;
            }
            if (!selectionComplete) return;

            var v = typeof swatch.findVariantFromSelected === 'function'
              ? swatch.findVariantFromSelected()
              : null;

            if (v) {
              if (v.id !== this.currentVariantId) {
                // Thumbnail keeps the old variant's media until the
                // render lands — flag it so the shopper knows the image
                // is catching up, not wrong.
                this._setSwatchMediaPending(true);
                this._applyVariantState(v, null, { skipPreview: true });
              }
            } else {
              /*
                Complete selection that resolves to NO variant (a combo
                we don't produce). Null the id and hold the button so a
                click can't fall back to the stale form id; the in-flight
                section render will publish variantChange and settle the
                real face ("Select options" / "Not offered").
              */
              this.currentVariantId = null;
              this._setSwatchMediaPending(true);
              if (this.button && !this.isGuest) {
                this.button.disabled = true;
                this._setAtcLabel('Updating\u2026');
              }
            }
          });
        };
        swatch.addEventListener('click', this._onSwatchInteract);
        swatch.addEventListener('change', this._onSwatchInteract);
      }

      this.syncPills(swatch);
    }

    syncPills(swatch) {
      if (!this.pillsContainer || !swatch) return;

      var pills = this.pillsContainer.querySelectorAll('[data-dd-sf-pill]');
      pills.forEach((pill) => {
        var optName = pill.dataset.ddSfPill;
        var group = swatch.querySelector('[data-dd-option-group][data-option-name="' + optName + '"]');
        if (!group) return;

        var val = null;
        var meta = null;
        var normalizeGram = function (raw) {
          var cleaned = String(raw == null ? '' : raw)
            .replace(/"/g, '')
            .replace(/\bgrams?\b/gi, '')
            .replace(/g/gi, '')
            .trim();
          return cleaned ? cleaned + 'g' : null;
        };

        var stdSelected = group.querySelector('[data-dd-pill-item].is--selected, [data-dd-swatch-item].is--selected');
        if (stdSelected && stdSelected.dataset.value) {
          val = stdSelected.dataset.value;
          if (stdSelected.dataset.gramAmount) meta = normalizeGram(stdSelected.dataset.gramAmount);
          else if (stdSelected.dataset.nickname) meta = stdSelected.dataset.nickname;
        }

        if (!val) {
          var drawerSelected = group.querySelector('.dd-option-drawer__item.is--selected');
          if (drawerSelected && drawerSelected.dataset.value) {
            val = drawerSelected.dataset.value;
            if (drawerSelected.dataset.gramAmount) meta = normalizeGram(drawerSelected.dataset.gramAmount);
            else if (drawerSelected.dataset.nickname) meta = drawerSelected.dataset.nickname;
          }
        }

        if (!val) {
          var label = group.querySelector('[data-dd-selected-label]');
          if (label) {
            var strongEl = label.querySelector('strong');
            var rawText = (strongEl ? strongEl.textContent : label.textContent).trim();
            if (rawText) val = rawText;
          }
        }

        if (val) {
          var display = val;
          if (/^length$/i.test(optName)) {
            display = display.replace(/\s*inches?\s*/gi, '').replace(/"/g, '').trim() + '"';
          }
          this._swapText(pill, meta ? display + ' \u00b7 ' + meta : display);
          pill.classList.add('is--selected');
        } else {
          this._swapText(pill, 'Select ' + optName);
          pill.classList.remove('is--selected');
        }
      });
    }

    /* Pill sync for PDPs WITHOUT a dd-swatch-selector (standard Dawn picker,
       e.g. the event-certification toolkit choice). syncPills() reads selected
       state out of the swatch DOM, which doesn't exist here — instead map the
       variant's options array onto the pills by position (DOM order matches
       product.options_with_values order, which matches option1/2/3). */
    syncPillsFromVariant(variant) {
      if (!this.pillsContainer || !variant || !variant.options) return;
      var pills = this.pillsContainer.querySelectorAll('[data-dd-sf-pill]');
      pills.forEach((pill, i) => {
        var val = variant.options[i];
        if (val == null || val === '') return;
        var display = String(val);
        if (/^length$/i.test(pill.dataset.ddSfPill || '')) {
          display = display.replace(/\s*inches?\s*/gi, '').replace(/"/g, '').trim() + '"';
        }
        this._swapText(pill, display);
        pill.classList.add('is--selected');
      });
    }

    updateSwatchPreview(variant) {
      if (!this.swatchPreview) return;

      // Capture the Liquid-resolved server-rendered <img src> on the very
      // first call — before any JS swap can mutate it. Liquid already walks
      // the full fallback chain in sections/main-product.liquid:
      //   variant.metafields.custom.variant_image 4th entry IF video
      //     → variant.metafields.custom.variant_image 2nd entry (still), else 1st
      //     → variant.featured_media.preview_image
      //     → variant.image
      //     → product.featured_image
      // The JS chain below mirrors the first three steps (gallery 4th-slot
      // video + 2nd gallery image else 1st + variant.featured_image.src). It
      // cannot see `product.featured_image` because that field isn't on the
      // variant JSON. For products with no per-variant media (e.g. the
      // single-image course PDP), Liquid lands on `product.featured_image` and
      // JS lands on `null`, which used to hide the chip via
      // `style.display='none'`. Stashing the initial src gives us the same
      // final fallback without a server data-attr.
      if (this._initialSwatchSrc === undefined) {
        var initImg = this.swatchPreview.querySelector('img');
        this._initialSwatchSrc = initImg && initImg.getAttribute('src') || null;
      }

      // On variant change, the PDP gallery is the source of truth for the
      // selected variant's ordered media list (it's rebuilt from
      // `custom.variant_image`). Ask it for the 4th-slot looping VIDEO; if
      // there's no video (4th slot is an image, or fewer than 4 slides) we
      // fall back to the 2nd variant image (else 1st) — mirrors the Liquid
      // priority used on initial render in sections/main-product.liquid.
      var media = this.getFourthGalleryMedia(variant);

      if (!media) {
        var stillImg = this.getSwatchStillImage();
        if (stillImg) media = { type: 'image', src: stillImg };
      }

      if (!media && variant && variant.featured_image && variant.featured_image.src) {
        media = { type: 'image', src: variant.featured_image.src };
      }

      if (!media && this._initialSwatchSrc) {
        media = { type: 'image', src: this._initialSwatchSrc };
      }

      if (!media) {
        var existing = this.swatchPreview.querySelector('img, video');
        if (existing) existing.style.display = 'none';
        this._setSwatchMediaPending(false);
        return;
      }

      if (media.type === 'video') {
        this._renderSwatchVideo(media);
      } else {
        this._renderSwatchImage(media.src);
      }

      this._settleSwatchMediaPending();
    }

    _renderSwatchImage(src) {
      var thumbSrc = src;
      if (thumbSrc.indexOf('width=') === -1) {
        thumbSrc += (thumbSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120&height=120&crop=center';
      }

      // If a <video> was rendered for the previous variant, pull it so the
      // <img> can take the slot. We don't keep both — `:empty` CSS hides
      // the wrapper when there's nothing to show, and stacking two media
      // elements would double-paint.
      var staleVideo = this.swatchPreview.querySelector('video');
      if (staleVideo) staleVideo.remove();

      var img = this.swatchPreview.querySelector('img');
      if (img) {
        img.style.display = '';
        this._swapImage(img, thumbSrc);
      } else {
        var newImg = document.createElement('img');
        newImg.src = thumbSrc;
        newImg.alt = '';
        newImg.width = 44;
        newImg.height = 44;
        newImg.loading = 'lazy';
        this.swatchPreview.appendChild(newImg);
      }
    }

    _primeSwatchVideo(video) {
      if (!video) return;
      if (window.ddPrimeInlineVideo) window.ddPrimeInlineVideo(video);
      else {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.removeAttribute('controls');
      }
      if (!video.__ddSwatchPlayingBound) {
        video.__ddSwatchPlayingBound = true;
        video.addEventListener('playing', function () {
          video.classList.add('is--playing');
          try {
            video.removeAttribute('poster');
          } catch (_) {}
        });
      }
    }

    _kickSwatchPreviewVideo() {
      // Idempotent: safe to call whether or not a <video> is present, and
      // whether or not it's already playing. Waits two frames after the
      // host flips display:none → block so mobile Chrome/WebKit see a
      // laid-out, visible target before play(). Also waits for canplay
      // when preload="metadata" (server-rendered swatch clips).
      if (!this.swatchPreview) return;
      var video = this.swatchPreview.querySelector('video');
      if (!video) return;
      this._primeSwatchVideo(video);
      this._bindSwatchVideoSelfHeal(video);
      if (this.classList.contains('is--visible')) {
        video.preload = 'auto';
      }
      if (window.ddPlayInlineVideo) {
        window.ddPlayInlineVideo(video, { layoutFrames: 2, restart: false }).then(function () {
          if (!video.paused) video.classList.add('is--playing');
        });
        return;
      }
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          if (!video.paused) video.classList.add('is--playing');
        }).catch(function () {});
      }
    }

    /* Self-heal the 44×44 swatch video when something external pauses it.
       Dawn's media-gallery.js historically called `window.pauseAllMedia()`
       (assets/global.js) on every slide activation, which pauses every
       <video> on the page — including this sticky swatch preview. Modal
       opens and deferred-media loads call it too. Logged-in customers
       never saw this stall because the product form's subsequent
       variant:change re-kicked the sticky preview via updateSwatchPreview
       → _renderSwatchVideo → video.play(). Guests on non-gated PDPs don't
       always get that re-kick (the product form may not hydrate when the
       ATC slot is replaced with a login button), so the sticky swatch
       sat paused on the poster frame.

       We now scope the gallery's pause to its own subtree (see
       media-gallery.js playActiveMedia), and also defend here in case
       another caller of `pauseAllMedia` (modal open/close, deferred-media
       loadContent, future consumers) reaches in and pauses us. The
       listener only re-kicks while the sticky is intended to be visible —
       browsers auto-pause videos in `display: none` subtrees and we
       mustn't fight that. */
    _bindSwatchVideoSelfHeal(video) {
      if (!video || video.__ddSwatchSelfHealBound) return;
      video.__ddSwatchSelfHealBound = true;
      var self = this;
      video.addEventListener('pause', function () {
        if (!self.classList.contains('is--visible')) return;
        if (self.classList.contains('is--exiting')) return;
        // Defer a frame so we don't loop synchronously with an external
        // pause/play cycle and to let the DOM settle (e.g. after a
        // display swap).
        requestAnimationFrame(function () {
          if (!self.classList.contains('is--visible')) return;
          if (self.classList.contains('is--exiting')) return;
          if (!video.paused) return;
          self._primeSwatchVideo(video);
          if (window.ddPlayInlineVideo) {
            window.ddPlayInlineVideo(video, { layoutFrames: 1, restart: false }).then(function () {
              if (!video.paused) video.classList.add('is--playing');
            });
            return;
          }
          var p = video.play();
          if (p && typeof p.then === 'function') {
            p.then(function () {
              if (!video.paused) video.classList.add('is--playing');
            }).catch(function () {});
          }
        });
      });
    }

    _renderSwatchVideo(media) {
      // Remove any <img> that was showing for a previous (image-type)
      // variant so we don't stack media elements in the 44×44 slot.
      var staleImg = this.swatchPreview.querySelector('img');
      if (staleImg) staleImg.remove();

      var video = this.swatchPreview.querySelector('video');
      var sources = Array.isArray(media.sources) ? media.sources : [];
      var primarySrc = sources.length ? sources[0].url : media.src;

      if (!video) {
        video = document.createElement('video');
        video.autoplay = true;
        video.loop = true;
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('aria-hidden', 'true');
        video.preload = 'metadata';
        video.className = 'dd-sticky-footer__swatch-video';
        this._primeSwatchVideo(video);
        this.swatchPreview.appendChild(video);
      } else {
        this._primeSwatchVideo(video);
      }

      video.style.display = '';
      if (media.poster) video.poster = media.poster;

      // Swap sources only when the primary URL changed — avoids the visible
      // reload flash when the user cycles between variants whose 4th slide
      // happens to be the same clip.
      if (video.dataset.ddSrc !== primarySrc) {
        video.dataset.ddSrc = primarySrc;

        while (video.firstChild) video.removeChild(video.firstChild);

        if (sources.length) {
          sources.forEach(function (s) {
            var source = document.createElement('source');
            source.src = s.url;
            if (s.mimeType) source.type = s.mimeType;
            video.appendChild(source);
          });
        } else if (primarySrc) {
          video.src = primarySrc;
        }

        try {
          video.load();
        } catch (_) {
          /* load() is best-effort; some engines throw in detached states */
        }
      }

      // Attach the self-heal listener before the first play() so the
      // handler is live if another section (modal, deferred-media) pauses
      // us between now and the next shopper interaction.
      this._bindSwatchVideoSelfHeal(video);

      // Kick playback after sources settle. If the sticky is still hidden,
      // play() may reject — _kickSwatchPreviewVideo() re-runs on show.
      var layoutFrames = this.classList.contains('is--visible') ? 2 : 0;
      if (this.classList.contains('is--visible')) video.preload = 'auto';
      if (window.ddPlayInlineVideo) {
        window.ddPlayInlineVideo(video, { layoutFrames: layoutFrames, restart: false }).then(function () {
          if (!video.paused) video.classList.add('is--playing');
        });
      } else {
        var p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(function () {
            if (!video.paused) video.classList.add('is--playing');
          }).catch(function () {});
        }
      }
    }

    _collectGalleryMediaSlides() {
      var mg = document.querySelector('product-info media-gallery');
      if (!mg) return null;
      var viewer = mg.querySelector('slider-element') || mg.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return null;

      // Iterate actual gallery slides (not the desktop `.product__preview`
      // clone, which duplicates slide 1). Each visible slide corresponds to
      // one entry in the variant's `custom.variant_image` metafield, in order.
      var slides = viewer.querySelectorAll('[data-media-id]:not([hidden])');
      var mediaSlides = [];
      slides.forEach(function (slide) {
        if (slide.closest('.product__preview')) return;
        // A slide counts as `video` only when it holds a real <video>
        // (a hosted video media). External-video / 3D-model slides render a
        // <deferred-media> poster <img>, so they count here as `image`
        // slides showing that poster frame — not as videos.
        var im = slide.querySelector('img');
        var vid = slide.querySelector('video');
        if (vid) {
          mediaSlides.push({ slide: slide, kind: 'video', el: vid });
        } else if (im && im.src && im.src.indexOf('data:') !== 0) {
          mediaSlides.push({ slide: slide, kind: 'image', el: im });
        }
      });
      return mediaSlides;
    }

    getFourthGalleryMedia(variant) {
      var mediaSlides = this._collectGalleryMediaSlides();
      if (!mediaSlides) return null;

      // The 4th slot drives ONLY the looping video (matches the Liquid
      // initial-render rule in sections/main-product.liquid). When the 4th
      // slide isn't a hosted video — or there are fewer than 4 slides — we
      // return null so the caller falls back to the 2nd variant image (else 1st).
      if (mediaSlides.length < 4) return null;
      var pick = mediaSlides[3];
      if (pick.kind !== 'video') return null;

      var sourceEls = pick.el.querySelectorAll('source');
      var sources = [];
      sourceEls.forEach(function (s) {
        if (s.src) sources.push({ url: s.src, mimeType: s.type || '' });
      });
      /* mp4 first — the gallery's video_tag lists HLS (.m3u8) before mp4,
         and iOS Safari autoplays HLS unreliably for hidden-at-parse
         background loops. Stable sort keeps rendition order otherwise. */
      sources.sort(function (a, b) {
        var am = (a.mimeType || '').indexOf('mp4') >= 0 ? 0 : 1;
        var bm = (b.mimeType || '').indexOf('mp4') >= 0 ? 0 : 1;
        return am - bm;
      });
      return {
        type: 'video',
        sources: sources,
        src: pick.el.currentSrc || pick.el.src || (sources[0] && sources[0].url) || null,
        poster: pick.el.poster || null,
      };
    }

    getSwatchStillImage() {
      var mediaSlides = this._collectGalleryMediaSlides();
      if (!mediaSlides || !mediaSlides.length) return null;

      // Mirror the server "2nd entry else 1st" swatch-card rule: prefer the
      // 2nd gallery slide, else the 1st. Gallery slide order == the variant's
      // `custom.variant_image` order, so positions line up with the metafield
      // entries the server reads. A video slide contributes its poster frame
      // (acceptable at 44×44), matching the server's preview_image fallback.
      var pick = mediaSlides[1] || mediaSlides[0];
      if (!pick) return null;
      if (pick.kind === 'image') {
        return pick.el.currentSrc || pick.el.src || null;
      }
      return pick.el.poster || null;
    }

    detectCustomSelection() {
      var swatch = document.querySelector('dd-swatch-selector');
      return swatch && typeof swatch.isCustomSelection === 'function'
        ? swatch.isCustomSelection()
        : false;
    }

    variantOptionsMentionCustom(variant) {
      if (!variant) return false;
      for (var i = 1; i <= 3; i++) {
        var o = variant['option' + i];
        if (o && String(o).toLowerCase().indexOf('custom') !== -1) return true;
      }
      return false;
    }

    isCustomForSticky(variant) {
      return this.detectCustomSelection() || this.variantOptionsMentionCustom(variant);
    }

    updateCustomBannerBadge() {
      if (!this.customBadgeEl) return;
      var sw = document.querySelector('dd-swatch-selector');
      if (!sw) {
        this._swapText(this.customBadgeEl, 'Custom item');
        return;
      }
      var texGroup = sw.querySelector(
        '[data-dd-option-group][data-option-name="Texture"], [data-dd-option-group][data-option-name="texture"]'
      );
      if (texGroup) {
        var texCustom =
          texGroup.querySelector('.dd-option-drawer__item.is--selected') ||
          texGroup.querySelector('[data-dd-custom-trigger][aria-expanded="true"]');
        if (texCustom) {
          this._swapText(this.customBadgeEl, 'Custom texture');
          return;
        }
      }
      var lenGroup = sw.querySelector('.dd-swatch-group--length');
      if (lenGroup) {
        var lenCustom =
          lenGroup.querySelector('[data-dd-custom-trigger].is--selected') ||
          lenGroup.querySelector('.dd-option-drawer__item.is--selected');
        if (lenCustom) {
          this._swapText(this.customBadgeEl, 'Custom length');
          return;
        }
      }
      this._swapText(this.customBadgeEl, 'Custom item');
    }

    _sumEventTicketsLeft() {
      var map = window._ddStockMap;
      if (!map) return null;
      var sum = 0;
      var hasTracked = false;
      Object.keys(map).forEach(function (id) {
        var qty = map[id];
        if (qty == null || isNaN(qty)) return;
        hasTracked = true;
        sum += Math.max(0, Number(qty));
      });
      return hasTracked ? sum : null;
    }

    updateEventTickets() {
      if (!this.shipTicketsText) return;
      var left = this._sumEventTicketsLeft();
      var soldOut = left != null && left <= 0;
      var text = soldOut ? 'Sold out' : 'Tickets available';
      this._swapText(this.shipTicketsText, text);
      if (this.shipTicketsDot) {
        this.shipTicketsDot.classList.toggle('dd-sticky-footer__ship-dot--soldout', soldOut);
        this.shipTicketsDot.classList.toggle('dd-sticky-footer__ship-dot--stock', !soldOut);
        this.shipTicketsDot.classList.toggle('dd-sticky-footer__ship-dot--lowstock', false);
        this.shipTicketsDot.classList.toggle('dd-sticky-footer__ship-dot--custom', false);
        this.shipTicketsDot.classList.toggle('dd-sticky-footer__ship-dot--digital', false);
      }
    }

    updateShippingAndCustom(variant) {
      if (this.classList.contains('dd-sticky-footer--event')) {
        this.updateEventTickets();
        return;
      }

      if (this.isGuest) return;

      var showInstock = false;
      var showLowstock = false;
      var showCustom = false;
      var showSold = false;
      var LOW_STOCK_THRESHOLD = 5;

      var stockKey = null;
      if (!variant) {
        stockKey = 'soldout';
      } else if (!variant.available) {
        // Combo-unavailable supersedes plain soldout: same DOM signal the
        // swatch grid uses to render "This color not offered with texture"
        // on the selected card. Mirroring it here keeps the sticky footer's
        // status pill consistent with what the shopper just saw on the
        // swatch, instead of "Awaiting Restock" which implies a future
        // restock event for a combo we don't actually produce.
        var ssElForStock = document.querySelector('dd-swatch-selector');
        var comboUnavailable = ssElForStock
          && typeof ssElForStock.isCurrentComboUnavailable === 'function'
          && ssElForStock.isCurrentComboUnavailable();
        stockKey = comboUnavailable ? 'notoffered' : 'soldout';
      } else if (variant.requires_shipping === false) {
        /*
          Non-physical product (e.g. online courses, digital downloads).
          Shopify exposes `requires_shipping: false` on these variants
          regardless of inventory_management; surface that as
          "Instantly available" instead of the standard ship-time copy.
          Takes precedence over custom/lowstock since none of those
          ship-time concepts apply to digital fulfillment.
        */
        stockKey = 'digital';
      } else if (this.isCustomForSticky(variant)) {
        stockKey = 'custom';
      } else {
        var stockMap = window._ddStockMap;
        var qty = stockMap ? stockMap[String(variant.id)] : null;
        if (qty != null && qty > 0 && qty < LOW_STOCK_THRESHOLD) {
          stockKey = 'lowstock';
          if (this.shipLowstockCount) this._swapNumber(this.shipLowstockCount, qty);
        } else {
          stockKey = 'instock';
        }
      }

      this._setStockState(stockKey);

      var showBanner = !!(variant && variant.available && this.isCustomForSticky(variant));
      if (this.customBanner) {
        this.customBanner.hidden = !showBanner;
        if (showBanner) this.updateCustomBannerBadge();
      }
    }

    bindDragCollapse() {
      var dragBar = this.querySelector('[data-dd-sf-drag-bar]');
      if (!dragBar) return;

      var self = this;
      var startY = 0;
      var startCollapsed = false;
      var DRAG_THRESHOLD = 30;
      var COLLAPSE_STORAGE_KEY = 'dd_sticky_collapsed';

      var savedState = sessionStorage.getItem(COLLAPSE_STORAGE_KEY);
      if (savedState === 'true') {
        this.classList.add('is--collapsed');
        if (typeof this._closeBundlePanel === 'function') this._closeBundlePanel({ force: true });
      }

      function onFooterCollapsedChange(collapsed) {
        if (collapsed && typeof self._closeBundlePanel === 'function') {
          self._closeBundlePanel({ force: true });
        }
      }

      function onPointerDown(e) {
        startY = e.clientY;
        startCollapsed = self.classList.contains('is--collapsed');
        document.addEventListener('pointermove', onPointerMove, { passive: true });
        document.addEventListener('pointerup', onPointerUp, { once: true });
        document.addEventListener('pointercancel', onPointerUp, { once: true });
      }

      function onPointerMove(e) {
        var deltaY = e.clientY - startY;

        if (startCollapsed && deltaY < -DRAG_THRESHOLD) {
          self.classList.remove('is--collapsed');
          sessionStorage.setItem(COLLAPSE_STORAGE_KEY, 'false');
        } else if (!startCollapsed && deltaY > DRAG_THRESHOLD) {
          self.classList.add('is--collapsed');
          sessionStorage.setItem(COLLAPSE_STORAGE_KEY, 'true');
          onFooterCollapsedChange(true);
        }
      }

      function onPointerUp() {
        document.removeEventListener('pointermove', onPointerMove);
      }

      dragBar.addEventListener('pointerdown', onPointerDown);

      dragBar.addEventListener('click', function () {
        var willCollapse = !self.classList.contains('is--collapsed');
        self.classList.toggle('is--collapsed');
        sessionStorage.setItem(COLLAPSE_STORAGE_KEY, self.classList.contains('is--collapsed') ? 'true' : 'false');
        if (willCollapse) onFooterCollapsedChange(true);
      });

      this._dragBarCleanup = function () {
        dragBar.removeEventListener('pointerdown', onPointerDown);
        document.removeEventListener('pointermove', onPointerMove);
      };
    }

    disconnectedCallback() {
      if (this._dragBarCleanup) this._dragBarCleanup();
      window.removeEventListener('resize', this._syncLayout);
      window.removeEventListener('scroll', this._onStickyScroll);
      window.removeEventListener('resize', this._onStickyScroll);
      if (this._onChatToggle) {
        document.removeEventListener('dd:chat:toggle', this._onChatToggle);
      }
      if (this._boundQtyInput && this._onBoundQtySync) {
        this._boundQtyInput.removeEventListener('input', this._onBoundQtySync);
        this._boundQtyInput.removeEventListener('change', this._onBoundQtySync);
      }
      if (typeof this._variantSubUnsubscribe === 'function') this._variantSubUnsubscribe();
      if (this._swatchRoot && this._onSwatchInteract) {
        this._swatchRoot.removeEventListener('click', this._onSwatchInteract);
        this._swatchRoot.removeEventListener('change', this._onSwatchInteract);
      }
      if (this._layoutRo) this._layoutRo.disconnect();
      if (this._atcMo) this._atcMo.disconnect();
      if (this._mainAtcIo) this._mainAtcIo.disconnect();
      if (this._footerIo) this._footerIo.disconnect();
      if (this._stickyHeightRo) this._stickyHeightRo.disconnect();
      if (this._mqColorGate && this._onColorGateMq) {
        if (this._mqColorGate.removeEventListener) {
          this._mqColorGate.removeEventListener('change', this._onColorGateMq);
        } else if (this._mqColorGate.removeListener) {
          this._mqColorGate.removeListener(this._onColorGateMq);
        }
      }
      if (this._onAppliedEvent) document.removeEventListener('dd:applied', this._onAppliedEvent);
      if (this._onAppliedStorage) window.removeEventListener('storage', this._onAppliedStorage);
      this._clearStickyHeight();
      if (this._previewRaf) cancelAnimationFrame(this._previewRaf);
    }
  }

  customElements.define('dd-sticky-footer', DdStickyFooter);
})();
